let Typologies =
    [ 
    //CSBT card for CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_30m.Steel
    {
    "id": "CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_30m.Steel",
    "name": "Composite Steel & Concrete Bridge - Multi-Girder",
    "subtitle": "30m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 689.5,
    "A4": 14.9,
    "A5": 5.0,
    "totalCarbon": 709.4,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Composite steel and reinforced concrete multi I-girder bridge deck, based off a total deck length of 30m and width of 15m. 4 no. steel I-girders with 275mm thick deck slab.",
    "references": [
        "SCI Composite highway bridge design (2010)",
        "Steel-concrete composite bridge design charts for eurocodes (2011)",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_30m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 689.5
        },
        {
            "name": "Transport (A4)",
            "value": 14.9
        },
        {
            "name": "Site activities (A5)",
            "value": 5.0
        }
    ],
    "materials": [
        {
            "name": "Steel Plate/Section",
            "value": 546.1
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 73.7
        },
        {
            "name": "Steel Rebar",
            "value": 58.1
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Steel I-Girders",
            "value": 496.4
        },
        {
            "name": "Steel Bracing",
            "value": 49.6
        },
        {
            "name": "Deck Slab",
            "value": 131.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1328kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "30m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/20"
        },
        {
            "name": "Number of Girders",
            "value": 4
        },
        {
            "name": "Main Girder Area",
            "value": "0.064m2"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "3.4%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_60m.Steel
    {
    "id": "CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_60m.Steel",
    "name": "Composite Steel & Concrete Bridge - Multi-Girder",
    "subtitle": "60m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 787.4,
    "A4": 16.2,
    "A5": 5.0,
    "totalCarbon": 808.6,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Composite steel and reinforced concrete multi I-girder bridge deck, based off a total deck length of 60m and width of 15m. 4 no. steel I-girders with 275mm thick deck slab.",
    "references": [
        "SCI Composite highway bridge design (2010)",
        "Steel-concrete composite bridge design charts for eurocodes (2011)",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_60m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 787.4
        },
        {
            "name": "Transport (A4)",
            "value": 16.2
        },
        {
            "name": "Site activities (A5)",
            "value": 5.0
        }
    ],
    "materials": [
        {
            "name": "Steel Plate/Section",
            "value": 645.3
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 73.7
        },
        {
            "name": "Steel Rebar",
            "value": 58.1
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Steel I-Girders",
            "value": 580.8
        },
        {
            "name": "Steel Bracing",
            "value": 64.5
        },
        {
            "name": "Deck Slab",
            "value": 131.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1368kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "60m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/20"
        },
        {
            "name": "Number of Girders",
            "value": 4
        },
        {
            "name": "Main Girder Area",
            "value": "0.075m2"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "3.4%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure_.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_30m.Steel
    {
    "id": "CT.Bridges.Superstructure_.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_30m.Steel",
    "name": "Composite Steel & Concrete Bridge - Ladder Deck",
    "subtitle": "30m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 690.0,
    "A4": 14.9,
    "A5": 5.0,
    "totalCarbon": 709.9,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Composite steel and reinforced concrete ladder bridge deck, based off a total deck length of 30m and width of 15m. Cross girders at 3.5 m spacing with 275mm thick deck slab.",
    "references": [
        "Steel Construction info",
        "BCSA - Bridges Preliminary Design Calculator",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure ",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure_.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_30m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 690.0
        },
        {
            "name": "Transport (A4)",
            "value": 14.9
        },
        {
            "name": "Site activities (A5)",
            "value": 5.0
        }
    ],
    "materials": [
        {
            "name": "Steel Plate",
            "value": 546.6
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 73.7
        },
        {
            "name": "Steel Rebar",
            "value": 58.1
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Main Girder ",
            "value": 421.9
        },
        {
            "name": "Cross Girder ",
            "value": 124.7
        },
        {
            "name": "Deck Slab",
            "value": 131.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1329kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "30m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/20"
        },
        {
            "name": "Main Girder Area",
            "value": "0.08m2"
        },
        {
            "name": "Cross Girder Spacing",
            "value": "3.5m"
        },
        {
            "name": "Cross Girder Length",
            "value": "11.7m"
        },
        {
            "name": "Cross Girder Area ",
            "value": "0.027m2"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "3.4%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_60m.Steel
    {
    "id": "CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_60m.Steel",
    "name": "Composite Steel & Concrete Bridge - Ladder Deck",
    "subtitle": "60m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 763.3,
    "A4": 15.9,
    "A5": 5.0,
    "totalCarbon": 784.2,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Composite steel and reinforced concrete ladder bridge deck, based off a total deck length of 60m and width of 15m. Cross girders at 3.5 m spacing with 275mm thick deck slab.",
    "references": [
        "Steel Construction info",
        "BCSA - Bridges Preliminary Design Calculator",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_60m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 763.3
        },
        {
            "name": "Transport (A4)",
            "value": 15.9
        },
        {
            "name": "Site activities (A5)",
            "value": 5.0
        }
    ],
    "materials": [
        {
            "name": "Steel Plate",
            "value": 620.9
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 73.7
        },
        {
            "name": "Steel Rebar",
            "value": 58.1
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Main Girder ",
            "value": 496.2
        },
        {
            "name": "Cross Girder ",
            "value": 124.7
        },
        {
            "name": "Deck Slab",
            "value": 131.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1359kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "60m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/20"
        },
        {
            "name": "Main Girder Area",
            "value": "0.16m2"
        },
        {
            "name": "Cross Girder Spacing",
            "value": "3.5m"
        },
        {
            "name": "Cross Girder Length",
            "value": "11.7m"
        },
        {
            "name": "Cross Girder Area ",
            "value": "0.027m2"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "3.4%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Steel_Box_Girder_and_Deck_60m.Steel
    {
    "id": "CT.Bridges.Superstructure.Steel_Box_Girder_and_Deck_60m.Steel",
    "name": "Steel Box Girder and Deck",
    "subtitle": "60m continuous span, 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 1073.3,
    "A4": 14.3,
    "A5": 0.2,
    "totalCarbon": 1088.0,
    "units": "kgCO2e/m2",
    "description": "Steel box girder and orthotropic steel bridge deck, based off a total deck length of 60m and width of 15m. 2 no. open topped trapezoidal steel box girders with cantilever cross-girders.",
    "references": [
        "SCI P185 Guidance Note 2.05",
        "Guidance notes on best practice in steel bridge construction Rev 3",
        "SCI P140 Design Guide for Composite Box Girder Bridges",
        "Second Edition 2004",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Steel_Box_Girder_and_Deck_60m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 1073.3
        },
        {
            "name": "Transport (A4)",
            "value": 14.3
        },
        {
            "name": "Site activities (A5)",
            "value": 0.2
        }
    ],
    "materials": [
        {
            "name": "Steel Plate",
            "value": 1083.2
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Asphalt",
            "value": 4.1
        }
    ],
    "components": [
        {
            "name": "Trapezoidal Steel Box Girder ",
            "value": 588.6
        },
        {
            "name": "Steel Orthotropic Deck",
            "value": 376.7
        },
        {
            "name": "Steel Cross Girders",
            "value": 117.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Surfacing",
            "value": 4.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "520kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "60m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/25"
        },
        {
            "name": "Depth of Box Sections",
            "value": "2.5m"
        },
        {
            "name": "Area per Box Section",
            "value": "0.10m2"
        },
        {
            "name": "Parallel Spacing of Box Sections ",
            "value": "7m"
        },
        {
            "name": "Spacing of Intermediate Web and Flange Stiffeners",
            "value": "1.75m"
        },
        {
            "name": "Spacing of Cross Beams and Cross Ties",
            "value": "3.5m"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Box_Girder_60m.Steel
    {
    "id": "CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Box_Girder_60m.Steel",
    "name": "Composite Steel & Concrete Bridge - Box Girder",
    "subtitle": "60m continuous span, 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 872.0,
    "A4": 17.3,
    "A5": 5.0,
    "totalCarbon": 894.4,
    "units": "kgCO2e/m2",
    "description": "Composite steel box girder and reinforced concrete bridge deck, based off a total deck length of 60m and width of 15m. 2 no. open topped trapezoidal steel box girders with 275mm thick deck slab.",
    "references": [
        "SCI P185 Guidance Note 2.05, Guidance notes on best practice in steel bridge construction Rev 3",
        "SCI P140 Design Guide for Composite Box Girder Bridges, Second Edition 2004",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Box_Girder_60m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 872.0
        },
        {
            "name": "Transport (A4)",
            "value": 17.3
        },
        {
            "name": "Site activities (A5)",
            "value": 5.0
        }
    ],
    "materials": [
        {
            "name": "Steel Plate",
            "value": 731.1
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 73.7
        },
        {
            "name": "Steel Rebar",
            "value": 58.1
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Open-Topped Trapezoidal Steel Box Girder",
            "value": 455.1
        },
        {
            "name": "Steel Bracing",
            "value": 276.0
        },
        {
            "name": "Deck Slab",
            "value": 131.9
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge ",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1403kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "30m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Span/Depth",
            "value": "L/25"
        },
        {
            "name": "Main Girder Area",
            "value": "0.018m2"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "3.4%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_30m.Reinforced_Concrete
    {
    "id": "CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_30m.Reinforced_Concrete",
    "name": "Prestressed Concrete Box Girder Bridge",
    "subtitle": "30m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 266.8,
    "A4": 31.7,
    "A5": 3.2,
    "totalCarbon": 301.8,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Prestressed Concrete Box girder bridge, based off a total deck length of 30m, width of 15m and depth of 1.9m. ",
    "references": [
        "CBDG's Best Construction Methods for Concrete Bridge Decks",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_30m.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 266.8
        },
        {
            "name": "Transport (A4)",
            "value": 31.7
        },
        {
            "name": "Site activities (A5)",
            "value": 3.2
        }
    ],
    "materials": [
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 174.5
        },
        {
            "name": "Steel Rebar",
            "value": 95.9
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Precast Concrete Box ",
            "value": 270.4
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1695kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "30m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Depth ",
            "value": "1.9m"
        },
        {
            "name": "Cross sectional Area of box girder",
            "value": "7.5 m2 "
        },
        {
            "name": "Steel Reinforcement",
            "value": "200 kg/m3"
        },
        {
            "name": "Prestressing Tendons",
            "value": "45 kg/m3"
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for in-situ concrete, 300 kg for precast concrete "
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_60m.Reinforced_Concrete
    {
    "id": "CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_60m.Reinforced_Concrete",
    "name": "Prestressed Concrete Box Girder Bridge",
    "subtitle": "60m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 314.6,
    "A4": 37.6,
    "A5": 3.6,
    "totalCarbon": 355.9,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Prestressed Concrete Box girder bridge, based off a total deck length of 60m, width of 15m and depth of 3.8 m ",
    "references": [
        "CBDG's Best Construction Methods for Concrete Bridge Decks",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Prestressed_Concrete_Box_Girder_Bridge_60m.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 314.6
        },
        {
            "name": "Transport (A4)",
            "value": 37.6
        },
        {
            "name": "Site activities (A5)",
            "value": 3.6
        }
    ],
    "materials": [
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 209.4
        },
        {
            "name": "Steel Rebar",
            "value": 115.0
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Precast Concrete Box ",
            "value": 324.4
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge ",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1959kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "60m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Depth",
            "value": "3.8m "
        },
        {
            "name": "Slab Thickness",
            "value": "275mm"
        },
        {
            "name": "Cross sectional Area of box girder",
            "value": "9 m2 "
        },
        {
            "name": "Steel Reinforcement",
            "value": "200 kg/m3"
        },
        {
            "name": "Prestressing Tendons",
            "value": "45 kg/m3"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for in-situ concrete, 300 kg for precast concrete "
        }
    ]
},
    //CSBT card for CT.Bridges.Superstructure.Precast_Pre-Tensioned_Beam_Bridge_30m.Concrete
    {
    "id": "CT.Bridges.Superstructure.Precast_Pre-Tensioned_Beam_Bridge_30m.Concrete",
    "name": "Precast Pre-Tensioned Beam Bridge",
    "subtitle": "30m simple span 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 263.5,
    "A4": 23.0,
    "A5": 5.9,
    "totalCarbon": 292.4,
    "units": "kgCO2e/m2 (deck area)",
    "description": "Precast pre-tensioned concrete beam deck, based off a total deck length of 30m and width of 15m. 11 beams with 245mm thick in-situ deck slab.",
    "references": [
        "Banagher Prestress Concrete Beams Technical Manual 3rd Edition",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Superstructure",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Superstructure.Precast_Pre-Tensioned_Beam_Bridge_30m.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 263.5
        },
        {
            "name": "Transport (A4)",
            "value": 23.0
        },
        {
            "name": "Site activities (A5)",
            "value": 5.9
        }
    ],
    "materials": [
        {
            "name": "Concrete RC50/60 CEM III 50% GGBS",
            "value": 130.6
        },
        {
            "name": "Steel Rebar/Tendons",
            "value": 64.7
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 65.7
        },
        {
            "name": "Bitumen Emulsion",
            "value": 0.8
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24.0
        },
        {
            "name": "Asphalt",
            "value": 6.7
        }
    ],
    "components": [
        {
            "name": "Precast Concrete Beams ",
            "value": 157.2
        },
        {
            "name": "Deck Slab",
            "value": 103.8
        },
        {
            "name": "Waterproofing",
            "value": 0.8
        },
        {
            "name": "Concrete Verge",
            "value": 24.0
        },
        {
            "name": "Surfacing",
            "value": 6.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "690kg/m2 (deck area)"
        },
        {
            "name": "Length",
            "value": "30m"
        },
        {
            "name": "Width",
            "value": "15m"
        },
        {
            "name": "Depth ",
            "value": "2m"
        },
        {
            "name": "Type of Beam from Banagher's Design Manual ",
            "value": "M8"
        },
        {
            "name": "Cross Sectional Area of Beam M8",
            "value": "0.39m2"
        },
        {
            "name": "Number of Beams",
            "value": 11
        },
        {
            "name": "Beam Spacing",
            "value": "1.3 m "
        },
        {
            "name": "Slab Thickness",
            "value": "245mm"
        },
        {
            "name": "Slab Reinforcement",
            "value": "2.5%"
        },
        {
            "name": "Surfacing Thickness",
            "value": "125mm"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for in-situ concrete, 300 kg for precast concrete "
        }
    ]
},
    //CSBT card for CT.Bridges_.Superstructure.GFRP_Modular_Footbridge.GFRP
    {
    "id": "CT.Bridges_.Superstructure.GFRP_Modular_Footbridge.GFRP",
    "name": "GFRP Modular Footbridge",
    "subtitle": "Based on arcoBridge drawings. 19 GFRP Modules, 19.203 m span x  2.779m wide section. ",
    "category": "Bridges ",
    "subCategory": "Superstructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "GFRP",
    "region": "UK",
    "carbonDatabase": "FRP Carbon Factor (glass pallet) reference: Table 10-1, Structural Materials and Global Climate : A Primer on Carbon Emissions for Structural Engineers, Carbon Task Group, 2017",
    "A1-3": 932.4,
    "A4": 6.0,
    "A5": 0.0,
    "totalCarbon": 938.5,
    "units": "kgCO2e/m2",
    "description": "GFRP Modules spaced at 1000mm centres. Embodied carbon calculated for GFRP modules, post-tensioning tendons, GFRP walkway and  GFRP walkway beams.  Steel termination units are not included. A5 is not calculated as there is assumed to be no wastage for GFRP modules and post-tensioning tendons. After use, the majority of GFRP is currently disposed as landfill - it is not easily recycled.",
    "references": [
        "FRP Carbon Factor (glass pallet) reference: Table 10-1, Structural Materials and Global Climate : A Primer on Carbon Emissions for Structural Engineers, Carbon Task Group, 2017",
        "GFRP Density reference: Composites: Calculating their embodied energy (page 132), UNSW, S.Kara and S.Manmek, 2009",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges ",
        "Superstructure",
        "GFRP",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges_.Superstructure.GFRP_Modular_Footbridge.GFRP.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 932.4
        },
        {
            "name": "Transport (A4)",
            "value": 6.0
        },
        {
            "name": "Site activities (A5)",
            "value": 0.0
        }
    ],
    "materials": [
        {
            "name": "GFRP",
            "value": 921.6
        },
        {
            "name": "Steel Plate",
            "value": 16.8
        }
    ],
    "components": [
        {
            "name": "GFRP Modules",
            "value": 625.4
        },
        {
            "name": "Post-tensioning tendons",
            "value": 16.8
        },
        {
            "name": "GFRP Supporting beams for walkway",
            "value": 79.0
        },
        {
            "name": "Solid GFRP Walkway - Sandwich Panel",
            "value": 217.2
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight ",
            "value": "189kg/m2 (deck area)"
        },
        {
            "name": "Assumed Design Life ",
            "value": "120 years but likely to be less"
        },
        {
            "name": "FRP Carbon Factor (glass pallet)",
            "value": 5.02
        },
        {
            "name": "Length",
            "value": "19.203 m (19 GFRP modules @ 1000mm c/c)"
        },
        {
            "name": "Overall Clear Width",
            "value": "2.779m"
        },
        {
            "name": "GFRP Walkway Panel Width with Slip Resistant Surface",
            "value": "1.75m"
        },
        {
            "name": "GFRP Walkway Thickness",
            "value": "25mm"
        },
        {
            "name": "4 No. GRP Walkway Supporting Beams",
            "value": "50mm wide x 80mm deep x 995mm long"
        },
        {
            "name": "3 No. Post-tensioning Tendons ",
            "value": "32mm Diameter"
        },
        {
            "name": "Transport Distances",
            "value": "300km for GFRP, 300km for post-tensioning tendons"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Bank_Seat_Abutment.Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Bank_Seat_Abutment.Reinforced_Concrete",
    "name": "Bank Seat Abutment",
    "subtitle": "Bankseat abutment with wing walls for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 57317.6,
    "A4": 4591.1,
    "A5": 2422.6,
    "totalCarbon": 64331.3,
    "units": "kgCO2e",
    "description": "Simple in-situ mass concrete (lightly reinforced) bankseat with spread footing and wing walls, backfilled with MOT Type 1 material. 15m wide x 3.5m retained height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Bank_Seat_Abutment.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 57317.6
        },
        {
            "name": "Transport (A4)",
            "value": 4591.1
        },
        {
            "name": "Site activities (A5)",
            "value": 2422.6
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 42825.4
        },
        {
            "name": "Steel Rebar",
            "value": 17263.8
        },
        {
            "name": "Bitumen Emulsion",
            "value": 55.1
        },
        {
            "name": "General Aggregate",
            "value": 4187.0
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 26947.8
        },
        {
            "name": "Stem",
            "value": 17849.0
        },
        {
            "name": "Back Wall",
            "value": 5501.5
        },
        {
            "name": "Wing Walls",
            "value": 9790.9
        },
        {
            "name": "Waterproofing",
            "value": 55.1
        },
        {
            "name": "Backfill",
            "value": 4187.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "753t"
        },
        {
            "name": "Abutment Width",
            "value": "15m"
        },
        {
            "name": "Retained Height",
            "value": "3.5m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.3% - 2.5%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete & backfill"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Cantilever_Wall_Abutment.Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Cantilever_Wall_Abutment.Reinforced_Concrete",
    "name": "Cantilever Wall Abutment",
    "subtitle": "Free cantilever abutment wall (T-section) with wing walls for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 171890.6,
    "A4": 21028.8,
    "A5": 8401.1,
    "totalCarbon": 201320.5,
    "units": "kgCO2e",
    "description": "T-section in-situ RC cantilever abutment wall with spread footing and wing walls, backfilled with MOT Type 1 material. 15m wide x 8m retained height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Cantilever_Wall_Abutment.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 171890.6
        },
        {
            "name": "Transport (A4)",
            "value": 21028.8
        },
        {
            "name": "Site activities (A5)",
            "value": 8401.1
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 111882.3
        },
        {
            "name": "Steel Rebar",
            "value": 55528.6
        },
        {
            "name": "Waterproofing",
            "value": 215.3
        },
        {
            "name": "General Aggregate",
            "value": 33694.4
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 60632.6
        },
        {
            "name": "Cantilever Wall",
            "value": 56335.6
        },
        {
            "name": "Wing Walls",
            "value": 50442.7
        },
        {
            "name": "Waterproofing",
            "value": 215.3
        },
        {
            "name": "Backfill",
            "value": 33694.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "3597t"
        },
        {
            "name": "Abutment Width",
            "value": "15m"
        },
        {
            "name": "Retained Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.3% - 2.5%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete & backfill"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Hammerhead_Pier.Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Hammerhead_Pier.Reinforced_Concrete",
    "name": "Hammerhead Pier",
    "subtitle": "Single solid stem pier with crosshead for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 27706.5,
    "A4": 1488.3,
    "A5": 954.4,
    "totalCarbon": 30149.2,
    "units": "kgCO2e",
    "description": "In-situ RC hammerhead pier with spread footing. 15m wide crosshead, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Hammerhead_Pier.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 27706.5
        },
        {
            "name": "Transport (A4)",
            "value": 1488.3
        },
        {
            "name": "Site activities (A5)",
            "value": 954.4
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 20042.7
        },
        {
            "name": "Steel Rebar",
            "value": 10106.5
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 8974.9
        },
        {
            "name": "Stem",
            "value": 8205.7
        },
        {
            "name": "Crosshead",
            "value": 12968.6
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "216t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 2.2%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Hammerhead_Pier_(Precast).Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Hammerhead_Pier_(Precast).Reinforced_Concrete",
    "name": "Hammerhead Pier (Precast)",
    "subtitle": "Single solid stem pier with crosshead for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 27706.5,
    "A4": 6890.1,
    "A5": 244.9,
    "totalCarbon": 34841.6,
    "units": "kgCO2e",
    "description": "Precast RC hammerhead pier with spread footing. 15m wide crosshead, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Hammerhead_Pier_(Precast).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 27706.5
        },
        {
            "name": "Transport (A4)",
            "value": 6890.1
        },
        {
            "name": "Site activities (A5)",
            "value": 244.9
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 24735.0
        },
        {
            "name": "Steel Rebar",
            "value": 10106.5
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 10426.6
        },
        {
            "name": "Stem",
            "value": 9422.3
        },
        {
            "name": "Crosshead",
            "value": 14992.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "216t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 2.2%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 300km for precast concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Column_Pier.Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Column_Pier.Reinforced_Concrete",
    "name": "Column Pier",
    "subtitle": "Multi-column pier with crosshead for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 43728.8,
    "A4": 2358.6,
    "A5": 1534.8,
    "totalCarbon": 47622.2,
    "units": "kgCO2e",
    "description": "In-situ RC 4-column pier with crosshead, fender and spread footing. 15m wide crosshead, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Column_Pier.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 43728.8
        },
        {
            "name": "Transport (A4)",
            "value": 2358.6
        },
        {
            "name": "Site activities (A5)",
            "value": 1534.8
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 32231.3
        },
        {
            "name": "Steel Rebar",
            "value": 15390.9
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 12821.3
        },
        {
            "name": "Columns",
            "value": 7608.9
        },
        {
            "name": "Crosshead",
            "value": 9567.0
        },
        {
            "name": "Fender",
            "value": 17625.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "346t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 2.2%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Column_Pier_(Precast).Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Column_Pier_(Precast).Reinforced_Concrete",
    "name": "Column Pier (Precast)",
    "subtitle": "Multi-column pier with crosshead for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 43728.8,
    "A4": 11045.5,
    "A5": 989.0,
    "totalCarbon": 55763.3,
    "units": "kgCO2e",
    "description": "Precast RC 4-column pier with crosshead, fender and spread footing. 15m wide crosshead, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Column_Pier_(Precast).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 43728.8
        },
        {
            "name": "Transport (A4)",
            "value": 11045.5
        },
        {
            "name": "Site activities (A5)",
            "value": 989.0
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 40372.3
        },
        {
            "name": "Steel Rebar",
            "value": 15390.9
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 14895.1
        },
        {
            "name": "Columns",
            "value": 8737.1
        },
        {
            "name": "Crosshead",
            "value": 11060.2
        },
        {
            "name": "Fender",
            "value": 21070.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "346t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 2.2%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 300km for precast concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Solid_Wall_Pier.Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Solid_Wall_Pier.Reinforced_Concrete",
    "name": "Solid Wall Pier",
    "subtitle": "Solid wall pier for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 60242.0,
    "A4": 3247.4,
    "A5": 2109.0,
    "totalCarbon": 65598.4,
    "units": "kgCO2e",
    "description": "In-situ RC solid wall pier with spread footing. 15m wide wall, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Solid_Wall_Pier.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 60242.0
        },
        {
            "name": "Transport (A4)",
            "value": 3247.4
        },
        {
            "name": "Site activities (A5)",
            "value": 2109.0
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 44289.9
        },
        {
            "name": "Steel Rebar",
            "value": 21308.5
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 23078.3
        },
        {
            "name": "Wall",
            "value": 42520.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "475t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 1.9%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Substructure.Solid_Wall_Pier_(Precast).Reinforced_Concrete
    {
    "id": "CT.Bridges.Substructure.Solid_Wall_Pier_(Precast).Reinforced_Concrete",
    "name": "Solid Wall Pier (Precast)",
    "subtitle": "Solid wall pier for 2-lane single carriageway highway bridge",
    "category": "Bridges",
    "subCategory": "Substructure",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 60242.0,
    "A4": 15184.4,
    "A5": 541.2,
    "totalCarbon": 75967.5,
    "units": "kgCO2e",
    "description": "Precast RC solid wall pier with spread footing. 15m wide wall, 8m pier height.",
    "references": [
        "ICE Manual of Bridge Engineering 2008 Institution of Civil Engineers",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Substructure",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Substructure.Solid_Wall_Pier_(Precast).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 60242.0
        },
        {
            "name": "Transport (A4)",
            "value": 15184.4
        },
        {
            "name": "Site activities (A5)",
            "value": 541.2
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 54659.0
        },
        {
            "name": "Steel Rebar",
            "value": 21308.5
        }
    ],
    "components": [
        {
            "name": "Spread Footing",
            "value": 26811.2
        },
        {
            "name": "Wall",
            "value": 49156.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "475t"
        },
        {
            "name": "Pier Width",
            "value": "15m"
        },
        {
            "name": "Pier Height",
            "value": "8m"
        },
        {
            "name": "Reinforcement Ratio",
            "value": "1.7% - 1.9%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 300km for precast concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Parapets_.Steel_Parapet_(N2).Steel
    {
    "id": "CT.Bridges.Parapets_.Steel_Parapet_(N2).Steel",
    "name": "Steel Parapet (N2)",
    "subtitle": "Normal containment (N2) steel vehicle parapet",
    "category": "Bridges",
    "subCategory": "Parapets ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 253.4,
    "A4": 23.1,
    "A5": 0.8,
    "totalCarbon": 277.2,
    "units": "kgCO2e/m (deck length)",
    "description": "0.94 m nominal height, 3-rail system with post and anchor system at 3.70m centres",
    "references": [
        "Tata Steel Design Drawings and Specification for N2 Parapet January 2011",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Parapets ",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Parapets_.Steel_Parapet_(N2).Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 253.4
        },
        {
            "name": "Transport (A4)",
            "value": 23.1
        },
        {
            "name": "Site activities (A5)",
            "value": 0.8
        }
    ],
    "materials": [
        {
            "name": "Steel Plate/Section",
            "value": 143.8
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 80.5
        },
        {
            "name": "Steel Rebar",
            "value": 52.8
        }
    ],
    "components": [
        {
            "name": "Steel Posts",
            "value": 49.4
        },
        {
            "name": "Horizontal Rails ",
            "value": 80.1
        },
        {
            "name": "Base Plate",
            "value": 14.3
        },
        {
            "name": "Parapet Edge Beam",
            "value": 133.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "722kg/m (deck length)"
        },
        {
            "name": "Nominal Parapet Height ",
            "value": "940mm"
        },
        {
            "name": "Post Section Size ",
            "value": "100 x 100 x 8 SHS"
        },
        {
            "name": "No. of Rails ",
            "value": 3
        },
        {
            "name": "Rail Size ",
            "value": "100 x 100 x 8 SHS"
        },
        {
            "name": "Base Plate Dimensions (mm)",
            "value": "330 x 330 x 25   "
        },
        {
            "name": "Parapet Edge Beam Dimensions",
            "value": "0.5 m x 0.5 m Cross Section"
        },
        {
            "name": "Parapet Edge Beam Reinforcement Percentage",
            "value": "3.4%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Parapets_.Steel_Parapet_(H4a).Steel
    {
    "id": "CT.Bridges.Parapets_.Steel_Parapet_(H4a).Steel",
    "name": "Steel Parapet (H4a)",
    "subtitle": "Very High containment (H4a) steel vehicle parapet",
    "category": "Bridges",
    "subCategory": "Parapets ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 381.6,
    "A4": 24.8,
    "A5": 0.8,
    "totalCarbon": 407.1,
    "units": "kgCO2e/m (deck length)",
    "description": "1.48m nominal height, 3-rail system with post and anchor system at 3.70m centres",
    "references": [
        "Tata Steel Design Drawings and Specification for H4a Parapet January 2011",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019\n"
    ],
    "tags": [
        "Bridges",
        "Parapets ",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Parapets_.Steel_Parapet_(H4a).Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 381.6
        },
        {
            "name": "Transport (A4)",
            "value": 24.8
        },
        {
            "name": "Site activities (A5)",
            "value": 0.8
        }
    ],
    "materials": [
        {
            "name": "Steel Plate/Section",
            "value": 273.7
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 80.5
        },
        {
            "name": "Steel Rebar",
            "value": 52.8
        }
    ],
    "components": [
        {
            "name": "Steel Posts ",
            "value": 34.9
        },
        {
            "name": "Horizontal Rails ",
            "value": 173.0
        },
        {
            "name": "Base Plate ",
            "value": 65.8
        },
        {
            "name": "Parapet Edge Beam",
            "value": 133.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "775kg/m (deck length)"
        },
        {
            "name": "Nominal Parapet Height ",
            "value": "1480mm"
        },
        {
            "name": "Post Section Size ",
            "value": "200 x 200 x 12.5 SHS"
        },
        {
            "name": "No. of Rails ",
            "value": 3
        },
        {
            "name": "Top Rail Size ",
            "value": "160 x 112 x 12.5 SHS"
        },
        {
            "name": "Mid and Bottom Rail Size",
            "value": "160 x 160 x 12.5 SHS"
        },
        {
            "name": "Base Plate Dimensions (mm)",
            "value": "500 x 550 x 50"
        },
        {
            "name": "Parapet Edge Beam Dimensions",
            "value": "0.5 m x 0.5 m Cross Section"
        },
        {
            "name": "Parapet Edge Beam Reinforcement Percentage",
            "value": "3.4%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Bridges.Parapets.Concrete_Parapet_(H4a).Pre-cast_Reinforced_Concrete
    {
    "id": "CT.Bridges.Parapets.Concrete_Parapet_(H4a).Pre-cast_Reinforced_Concrete",
    "name": "Concrete Parapet (H4a)",
    "subtitle": "Very High containment (H4a) reinforced concrete vehicle parapet",
    "category": "Bridges",
    "subCategory": "Parapets",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Pre-cast Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 300.8,
    "A4": 14.4,
    "A5": 9.0,
    "totalCarbon": 324.2,
    "units": "kgCO2e/m (deck length)",
    "description": "Very high containment (H4a) reinforced concrete vehicle parapet, 1.52m nominal height x 370 mm nominal width.",
    "references": [
        "Bridges and Civil Structures Forum, Arup",
        "Birmingham Northern Relief Road, January 2004",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Bridges",
        "Parapets",
        "Pre-cast Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Bridges.Parapets.Concrete_Parapet_(H4a).Pre-cast_Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 300.8
        },
        {
            "name": "Transport (A4)",
            "value": 14.4
        },
        {
            "name": "Site activities (A5)",
            "value": 9.0
        }
    ],
    "materials": [
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 188.3
        },
        {
            "name": "Steel Rebar",
            "value": 135.9
        }
    ],
    "components": [
        {
            "name": "Parapet Concrete ",
            "value": 188.3
        },
        {
            "name": "Parapet Reinforcement ",
            "value": 135.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "1850kg/m (deck length)"
        },
        {
            "name": "Nominal Parapet Height ",
            "value": "1.52 m"
        },
        {
            "name": "Nominal Parapet Width ",
            "value": "0.37m"
        },
        {
            "name": "Steel Reinforcement",
            "value": "2.8%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Reinforcement_Cage.Reinforced_Concrete
    {
    "id": "CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Reinforcement_Cage.Reinforced_Concrete",
    "name": "Segmental Lining with Reinforcement Cage",
    "subtitle": "9.6m external diameter. 400thk tunnel lining. ",
    "category": "Tunnels",
    "subCategory": "Tunnel Lining",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 5358.8,
    "A4": 1034.2,
    "A5": 207.8,
    "totalCarbon": 6600.8,
    "units": "kgCO2e/m (tunnel length)",
    "description": "Tunnel lining is 400thk with a 9.6m external diameter. Waterproofing is not included. Excavation of soil and site activities are not included. ",
    "references": [
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Tunnels",
        "Tunnel Lining",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Reinforcement_Cage.Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 5358.8
        },
        {
            "name": "Transport (A4)",
            "value": 1034.2
        },
        {
            "name": "Site activities (A5)",
            "value": 207.8
        }
    ],
    "materials": [
        {
            "name": "Concrete RC50/60 CEM III 50% GGBS",
            "value": 3316.6
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 1046.4
        },
        {
            "name": "Steel Rebar",
            "value": 1466.3
        }
    ],
    "components": [
        {
            "name": "Primary Lining",
            "value": 4232.1
        },
        {
            "name": "Second Stage Concrete",
            "value": 1597.2
        },
        {
            "name": "Excavation Area",
            "value": 771.4
        },
        {
            "name": "Waterproofing",
            "value": 0.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "40068kg/m (tunnel length)"
        },
        {
            "name": "Tunnel Lining Reinforcement Quantity",
            "value": "30kg/m3"
        },
        {
            "name": "Second Stage Concrete Reinforcement Ratio",
            "value": "2.0%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Steel_Fibre_Reinforced_Concrete_(SFRC).Reinforced_Concrete
    {
    "id": "CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Steel_Fibre_Reinforced_Concrete_(SFRC).Reinforced_Concrete",
    "name": "Segmental Lining with Steel Fibre Reinforced Concrete (SFRC)",
    "subtitle": "9.6m external diameter. 400thk tunnel lining. ",
    "category": "Tunnels",
    "subCategory": "Tunnel Lining",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 4743.8,
    "A4": 1008.3,
    "A5": 207.8,
    "totalCarbon": 5959.9,
    "units": "kgCO2e/m (tunnel length)",
    "description": "Tunnel lining is 400thk with a 9.6m external diameter. Waterproofing is not included. Excavation of soil and site activities are not included. ",
    "references": [
        "Long Itchington Wood Tunnel to Birmingham Interchange Station, Drg. No. 1MC08-BBV_MSD-TN-DPP-NS01_NL01-127051",
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Tunnels",
        "Tunnel Lining",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Steel_Fibre_Reinforced_Concrete_(SFRC).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 4743.8
        },
        {
            "name": "Transport (A4)",
            "value": 1008.3
        },
        {
            "name": "Site activities (A5)",
            "value": 207.8
        }
    ],
    "materials": [
        {
            "name": "Concrete RC50/60 CEM III 50% GGBS",
            "value": 3316.6
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 1046.4
        },
        {
            "name": "Steel Rebar",
            "value": 825.5
        }
    ],
    "components": [
        {
            "name": "Primary Lining",
            "value": 3591.3
        },
        {
            "name": "Second Stage Concrete",
            "value": 1597.2
        },
        {
            "name": "Excavation Area",
            "value": 771.4
        },
        {
            "name": "Waterproofing",
            "value": 0.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "39258kg/m (tunnel length)"
        },
        {
            "name": "Tunnel Lining Reinforcement Quantity",
            "value": "30kg/m3"
        },
        {
            "name": "Second Stage Concrete Reinforcement Ratio",
            "value": "2.0%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Tunnels.Tunnel_Lining.Primary_Lining_Only_(Single_Shell).Reinforced_Concrete
    {
    "id": "CT.Tunnels.Tunnel_Lining.Primary_Lining_Only_(Single_Shell).Reinforced_Concrete",
    "name": "Primary Lining Only (Single Shell)",
    "subtitle": "15m x 13m external diameter. 450thk tunnel lining.",
    "category": "Tunnels",
    "subCategory": "Tunnel Lining",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 9125.3,
    "A4": 2184.4,
    "A5": 798.3,
    "totalCarbon": 11727.2,
    "units": "kgCO2e/m (tunnel length)",
    "description": "Tunnel lining is 450thk with a 15m x 13m external diameter. Waterproofing is not included. Excavation of soil and site activities are not included. ",
    "references": [
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Tunnels",
        "Tunnel Lining",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Tunnels.Tunnel_Lining.Primary_Lining_Only_(Single_Shell).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 9125.3
        },
        {
            "name": "Transport (A4)",
            "value": 2184.4
        },
        {
            "name": "Site activities (A5)",
            "value": 798.3
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 8768.2
        },
        {
            "name": "Steel Rebar",
            "value": 1517.6
        }
    ],
    "components": [
        {
            "name": "Primary Lining",
            "value": 5035.7
        },
        {
            "name": "Secondary Lining",
            "value": 5032.3
        },
        {
            "name": "Excavation Area",
            "value": 1659.3
        },
        {
            "name": "Waterproofing",
            "value": 0.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "90358kg/m (tunnel length)"
        },
        {
            "name": "Tunnel Lining Reinforcement Quantity",
            "value": "30kg/m3"
        },
        {
            "name": "Second Stage Concrete Reinforcement Ratio",
            "value": "2.0%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Plain_Concrete.Concrete
    {
    "id": "CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Plain_Concrete.Concrete",
    "name": "Segmental Lining with Plain Concrete",
    "subtitle": "9.6m external diameter. 400thk tunnel lining. ",
    "category": "Tunnels",
    "subCategory": "Tunnel Lining",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 4086.4,
    "A4": 980.7,
    "A5": 207.8,
    "totalCarbon": 5274.8,
    "units": "kgCO2e/m (tunnel length)",
    "description": "Tunnel lining is 400thk with a 9.6m external diameter. Waterproofing is not included. Excavation of soil and site activities are not included. ",
    "references": [
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Tunnels",
        "Tunnel Lining",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Tunnels.Tunnel_Lining.Segmental_Lining_with_Plain_Concrete.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 4086.4
        },
        {
            "name": "Transport (A4)",
            "value": 980.7
        },
        {
            "name": "Site activities (A5)",
            "value": 207.8
        }
    ],
    "materials": [
        {
            "name": "Concrete RC50/60 CEM III 50% GGBS",
            "value": 3316.6
        },
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 1046.4
        },
        {
            "name": "Steel Rebar",
            "value": 140.3
        }
    ],
    "components": [
        {
            "name": "Primary Lining",
            "value": 3316.6
        },
        {
            "name": "Second Stage Concrete",
            "value": 1186.8
        },
        {
            "name": "Excavation Area",
            "value": 771.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "183193kg/m (tunnel length)"
        },
        {
            "name": "Second Stage Concrete Reinforcement Ratio",
            "value": "2.0%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //CSBT card for CT.Tunnels.Tunnel_Lining.Primary_and_Secondary_Lining_(SFRC_and_Rebar).Reinforced_Concrete
    {
    "id": "CT.Tunnels.Tunnel_Lining.Primary_and_Secondary_Lining_(SFRC_and_Rebar).Reinforced_Concrete",
    "name": "Primary and Secondary Lining (SFRC and Rebar)",
    "subtitle": "15m x 13m external diameter. 450thk primary lining (SFRC). 450thk secondary lining (rebar)",
    "category": "Tunnels",
    "subCategory": "Tunnel Lining",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Reinforced Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 15569.5,
    "A4": 2501.1,
    "A5": 1028.9,
    "totalCarbon": 18718.8,
    "units": "kgCO2e/m (tunnel length)",
    "description": "Primary lining is 450thk with steel fibre reinforced concrete. Secondary lining is 450thk with rebar. External diameter of tunnel lining is 15m x 13m. Waterproofing is not included. Excavation of soil and site activities are not included. ",
    "references": [
        "IStructE: How to calculate embodied carbon",
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Tunnels",
        "Tunnel Lining",
        "Reinforced Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "George Wright",
        "Ciara Norris",
        "Suzanne Evans"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/CT.Tunnels.Tunnel_Lining.Primary_and_Secondary_Lining_(SFRC_and_Rebar).Reinforced_Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 15569.5
        },
        {
            "name": "Transport (A4)",
            "value": 2501.1
        },
        {
            "name": "Site activities (A5)",
            "value": 1028.9
        }
    ],
    "materials": [
        {
            "name": "Concrete RC32/40 with 50% GGBS cement",
            "value": 8761.1
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 4849.6
        },
        {
            "name": "Steel Rebar",
            "value": 3448.7
        }
    ],
    "components": [
        {
            "name": "Primary Lining",
            "value": 4575.4
        },
        {
            "name": "Secondary Lining",
            "value": 7458.8
        },
        {
            "name": "Second Stage",
            "value": 5025.2
        },
        {
            "name": "Excavation Area",
            "value": 1659.3
        },
        {
            "name": "Waterproofing",
            "value": 0.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Self Weight",
            "value": "136235kg/m (tunnel length)"
        },
        {
            "name": "Primary and Secondary Tunnel Lining Reinforcement Quantity",
            "value": "30kg/m3"
        },
        {
            "name": "Second Stage Concrete Reinforcement Ratio",
            "value": "2.0%"
        },
        {
            "name": "Transport Distances",
            "value": "300km for steel, 50km for concrete"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.Rubble-mounded-crownwall.Rock
    {
    "id": "Ma.Maritime.Breakwaters.Rubble-mounded-crownwall.Rock",
    "name": "Rubble-mounded - crown wall",
    "subtitle": "Rubble-mound breakwater with crown wall - 15m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 22869.6,
    "A4": 8667.1,
    "A5": 2585.6,
    "totalCarbon": 34192.4,
    "units": "kgCO2e/m",
    "description": "Rubble-mound breakwater of 15 m height, with seaside 2H:1V main and filter layers of 6-10t and 1-3t rock respectively, landside 1.5H:1V filter layer and 0-500kg core material. Includes 4.5x3.0m crown wall + 1.5x5.0m concrete slab and toe and crest berms",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.Rubble-mounded-crownwall.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 22869.6
        },
        {
            "name": "Transport (A4)",
            "value": 8667.1
        },
        {
            "name": "Site activities (A5)",
            "value": 2585.6
        }
    ],
    "materials": [
        {
            "name": "6-10t rock",
            "value": 10191.2
        },
        {
            "name": "1-3t rock",
            "value": 6140.4
        },
        {
            "name": "0-500kg core material",
            "value": 5477.1
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 5629.8
        },
        {
            "name": "Steel Rebar",
            "value": 6666.4
        }
    ],
    "components": [
        {
            "name": "Crown element",
            "value": 16331.6
        },
        {
            "name": "Armoured layer + seaside toe berm",
            "value": 10191.2
        },
        {
            "name": "Second layer + landside toe berm",
            "value": 6140.4
        },
        {
            "name": "Core",
            "value": 5477.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "15.0m"
        },
        {
            "name": "Seaside slope",
            "value": "2H:1V"
        },
        {
            "name": "Landside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Crown wall dimensions",
            "value": "3.0 x 4.5m"
        },
        {
            "name": "Crown slab dimensions",
            "value": "1.5 x 5.0m"
        },
        {
            "name": "Steel proportion",
            "value": "150 kg steel / 1m3 reinforced concrete"
        },
        {
            "name": "Armoured layer thickness",
            "value": "3.0m"
        },
        {
            "name": "Second layer thickness",
            "value": "2.0m"
        },
        {
            "name": "Core top width",
            "value": "10.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "6.0m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.0m"
        },
        {
            "name": "Crest berm width",
            "value": "4.5m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.Rubble-mounded-9m.Rock
    {
    "id": "Ma.Maritime.Breakwaters.Rubble-mounded-9m.Rock",
    "name": "Rubble-mounded - 9m",
    "subtitle": "Rubble-mound breakwater without crown wall - 9m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 7701.1,
    "A4": 2130.3,
    "A5": 983.1,
    "totalCarbon": 10814.6,
    "units": "kgCO2e/m",
    "description": "Rubble-mound breakwater of 9 m height and crest width of 11.30m, with seaside 2H:1V  and landside 1.5H:1V main layer of 3-6t main layer, core of 1-3t rock and 80-500kg under layer. Includes 4m width toe berms.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.Rubble-mounded-9m.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 7701.1
        },
        {
            "name": "Transport (A4)",
            "value": 2130.3
        },
        {
            "name": "Site activities (A5)",
            "value": 983.1
        }
    ],
    "materials": [
        {
            "name": "3-6t rock",
            "value": 5126.9
        },
        {
            "name": "1-3t rock",
            "value": 4683.4
        },
        {
            "name": "0-500kg core material",
            "value": 1004.3
        }
    ],
    "components": [
        {
            "name": "Armoured layer + toe berms",
            "value": 5126.9
        },
        {
            "name": "Underlayer",
            "value": 4683.4
        },
        {
            "name": "Core",
            "value": 1004.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "8.5m"
        },
        {
            "name": "Seaside slope",
            "value": "2H:1V"
        },
        {
            "name": "Landside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Crest top width",
            "value": "11.30m"
        },
        {
            "name": "Armoured layer thickness",
            "value": "2.4m"
        },
        {
            "name": "Underlayer thickness",
            "value": "Min 1.0m"
        },
        {
            "name": "Core top width",
            "value": "10.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "4.0m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.0m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.Rubble-mounded-11m.Rock
    {
    "id": "Ma.Maritime.Breakwaters.Rubble-mounded-11m.Rock",
    "name": "Rubble-mounded - 11m",
    "subtitle": "Rubble-mound breakwater without crown wall - 11m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 9913.4,
    "A4": 7182.6,
    "A5": 1709.6,
    "totalCarbon": 18805.7,
    "units": "kgCO2e/m",
    "description": "Rubble-mound breakwater of 11 m height and crest width of 11.625m, with seaside 2H:1V  and landside 1.5H:1V main layer of 6-10t main layer, core of 1-3t rock and 80-500kg under layer. Includes 4m width toe berms.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.Rubble-mounded-11m.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 9913.4
        },
        {
            "name": "Transport (A4)",
            "value": 7182.6
        },
        {
            "name": "Site activities (A5)",
            "value": 1709.6
        }
    ],
    "materials": [
        {
            "name": "6-10t rock",
            "value": 10910.5
        },
        {
            "name": "3-6t rock",
            "value": 779.7
        },
        {
            "name": "1-3t rock",
            "value": 5463.6
        },
        {
            "name": "0-500kg core material",
            "value": 1652.0
        }
    ],
    "components": [
        {
            "name": "Armoured layer + seaside toe berm",
            "value": 10910.5
        },
        {
            "name": "Landside toe berm",
            "value": 779.7
        },
        {
            "name": "Core",
            "value": 5463.6
        },
        {
            "name": "Underlayer",
            "value": 1652.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "11.0m"
        },
        {
            "name": "Seaside slope",
            "value": "2H:1V"
        },
        {
            "name": "Landside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Crest top width",
            "value": "11.63m"
        },
        {
            "name": "Armoured layer thickness",
            "value": "3.0m"
        },
        {
            "name": "Underlayer thickness",
            "value": "Min 1.0m"
        },
        {
            "name": "Core top width",
            "value": "10.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "4.0m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.0m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.ConcreteArmourUnits-crownwall.Concrete
    {
    "id": "Ma.Maritime.Breakwaters.ConcreteArmourUnits-crownwall.Concrete",
    "name": "Concrete Armour Units - crown wall",
    "subtitle": "CAU breakwater with crown wall - 15m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 24103.5,
    "A4": 3989.4,
    "A5": 1930.3,
    "totalCarbon": 30023.3,
    "units": "kgCO2e/m",
    "description": "CAU breakwater of 15 m height, with seaside 1.5H:1V main and filter layers of CAU and 1-3t rock respectively, landside 1.5H:1V filter layer and 0-500kg core material. Includes 4.5x3.0m crown wall + 1.5x5.0m concrete slab and toe and crest berms",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.ConcreteArmourUnits-crownwall.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 24103.5
        },
        {
            "name": "Transport (A4)",
            "value": 3989.4
        },
        {
            "name": "Site activities (A5)",
            "value": 1930.3
        }
    ],
    "materials": [
        {
            "name": "Concrete RC25/30 with 70% GGBS cement",
            "value": 6162.0
        },
        {
            "name": "1-3t rock",
            "value": 6596.5
        },
        {
            "name": "0-500kg core material",
            "value": 4968.7
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 5629.8
        },
        {
            "name": "Steel Rebar",
            "value": 6666.4
        }
    ],
    "components": [
        {
            "name": "Armoured layer",
            "value": 5355.2
        },
        {
            "name": "Underlayer + toe berms",
            "value": 4827.9
        },
        {
            "name": "Core",
            "value": 2577.6
        },
        {
            "name": "Crown element",
            "value": 11342.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "9.0m"
        },
        {
            "name": "Seaside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Landside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Crown wall dimensions",
            "value": "3.0 x 4.5m"
        },
        {
            "name": "Crown slab dimensions",
            "value": "1.5 x 5.0m"
        },
        {
            "name": "Steel proportion",
            "value": "150 kg steel / 1m3 reinforced concrete"
        },
        {
            "name": "Armoured layer thickness",
            "value": "3.0m"
        },
        {
            "name": "Second layer thickness",
            "value": "2.0m"
        },
        {
            "name": "Core top width",
            "value": "10.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "6.0m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.0m"
        },
        {
            "name": "Crest berm width",
            "value": "4.5m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.ConcreteArmourUnits-15m.Massconcrete
    {
    "id": "Ma.Maritime.Breakwaters.ConcreteArmourUnits-15m.Massconcrete",
    "name": "Concrete Armour Units- 15m ",
    "subtitle": "CAU breakwater without crown wall - 15m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Mass concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 26626.2,
    "A4": 7781.4,
    "A5": 2641.4,
    "totalCarbon": 37049.1,
    "units": "kgCO2e/m",
    "description": "CAU breakwater of 15 m height, with symmetric 1.33H:1V CAU main layer and rock filter layer of 1-3t rock and core of 10m width and 0-500kg fill. Includes toe berms and geotextile",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Mass concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.ConcreteArmourUnits-15m.Massconcrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 26626.2
        },
        {
            "name": "Transport (A4)",
            "value": 7781.4
        },
        {
            "name": "Site activities (A5)",
            "value": 2641.4
        }
    ],
    "materials": [
        {
            "name": "3-6t rock",
            "value": 1443.9
        },
        {
            "name": "1-3t rock",
            "value": 5717.3
        },
        {
            "name": "60-300kg rock",
            "value": 508.8
        },
        {
            "name": "0-500kg core material",
            "value": 12593.1
        },
        {
            "name": "Concrete RC25/30 with 70% GGBS cement",
            "value": 16786.1
        }
    ],
    "components": [
        {
            "name": "CAU layer",
            "value": 16786.1
        },
        {
            "name": "Second layer",
            "value": 5717.3
        },
        {
            "name": "Core",
            "value": 12593.1
        },
        {
            "name": "Toe berms",
            "value": 1443.9
        },
        {
            "name": "Bedding",
            "value": 508.8
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "15.0m"
        },
        {
            "name": "Seaside slope",
            "value": "1.33H:1V"
        },
        {
            "name": "Landside slope",
            "value": "1.33H:1V"
        },
        {
            "name": "Crest top width",
            "value": "12.85m"
        },
        {
            "name": "CAU layer thickness",
            "value": "2.72m"
        },
        {
            "name": "Second layer thickness",
            "value": "1.6m"
        },
        {
            "name": "Core top width",
            "value": "10.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "4.5m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.5m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Breakwaters.Compositebreakwater-CAU.Massconcrete
    {
    "id": "Ma.Maritime.Breakwaters.Compositebreakwater-CAU.Massconcrete",
    "name": "Composite breakwater - CAU",
    "subtitle": "Composite CAU breakwater with crown wall - 12m height",
    "category": "Maritime",
    "subCategory": "Breakwaters",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Mass concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 74534.1,
    "A4": 3908.1,
    "A5": 4182.0,
    "totalCarbon": 82624.3,
    "units": "kgCO2e/m",
    "description": "Composite breakwater of 12 m height, with seaside 1.5H:1V CAU main layer and rock filter layer of 3-6t rock, landside vertical wall with 12m x 10m reinforced concrete crown element and 80-500kg underlayer. Includes toe and crest berms and geotextile",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Breakwaters",
        "Mass concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Breakwaters.Compositebreakwater-CAU.Massconcrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 74534.1
        },
        {
            "name": "Transport (A4)",
            "value": 3908.1
        },
        {
            "name": "Site activities (A5)",
            "value": 4182.0
        }
    ],
    "materials": [
        {
            "name": "3-6t rock",
            "value": 4554.8
        },
        {
            "name": "300-1000kg rock",
            "value": 124.6
        },
        {
            "name": "0-500kg core material",
            "value": 1039.8
        },
        {
            "name": "Concrete RC25/30 with 70% GGBS cement",
            "value": 6520.0
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 32170.0
        },
        {
            "name": "Steel Rebar",
            "value": 38215.1
        }
    ],
    "components": [
        {
            "name": "Crown element",
            "value": 70385.2
        },
        {
            "name": "Armoured layer",
            "value": 6520.0
        },
        {
            "name": "Underlayer",
            "value": 1039.8
        },
        {
            "name": "Core + seaside toe berm",
            "value": 4554.8
        },
        {
            "name": "Landside berm",
            "value": 124.6
        }
    ],
    "designAssumptions": [
        {
            "name": "Breakwater height",
            "value": "12.0 m"
        },
        {
            "name": "Seaside slope",
            "value": "1.5H:1V"
        },
        {
            "name": "Landside slope",
            "value": "Vertical"
        },
        {
            "name": "Crown wall dimensions",
            "value": "12.0 x 10.0m"
        },
        {
            "name": "Reinforcement steel proportion",
            "value": "150 kg steel / 1m3 reinforced concrete"
        },
        {
            "name": "Armoured layer thickness",
            "value": "3.6m"
        },
        {
            "name": "Underlayer thickness",
            "value": "Min 1.0m"
        },
        {
            "name": "Seaside toe berm width",
            "value": "5.0m"
        },
        {
            "name": "Landside toe berm width",
            "value": "4.5m"
        },
        {
            "name": "Crest berm width",
            "value": "7.5m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Revetments.Rockrevetment-7.5m.Rock
    {
    "id": "Ma.Maritime.Revetments.Rockrevetment-7.5m.Rock",
    "name": "Rock revetment - 7.5m",
    "subtitle": "Rock revetment - 7.5m height",
    "category": "Maritime",
    "subCategory": "Revetments",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 963.3,
    "A4": 438.2,
    "A5": 138.8,
    "totalCarbon": 1540.4,
    "units": "kgCO2e/m",
    "description": "7.5m height of 3-layered rock revetment with 1.5H:1V 300-1000kg rock main layer of 1.44m thickness, 2H:1V 25-270kg blinding second layer of variable thickness and 0-500kg rock third layer of 1.20m thickness and core characteristics. Includes geotextil and 300mm x 600 mm concrete kerb",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Revetments",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Revetments.Rockrevetment-optimised.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 963.3
        },
        {
            "name": "Transport (A4)",
            "value": 438.2
        },
        {
            "name": "Site activities (A5)",
            "value": 138.8
        }
    ],
    "materials": [
        {
            "name": "300-1000kg rock",
            "value": 210.3
        },
        {
            "name": "3-6t rock",
            "value": 628.6
        },
        {
            "name": "0-500kg core material",
            "value": 675.1
        },
        {
            "name": "Concrete RC25/30 with 70% GGBS cement",
            "value": 26.5
        }
    ],
    "components": [
        {
            "name": "Main layer",
            "value": 210.3
        },
        {
            "name": "Blinding",
            "value": 628.6
        },
        {
            "name": "Core and toe berm",
            "value": 675.1
        },
        {
            "name": "Top kerb",
            "value": 26.5
        }
    ],
    "designAssumptions": [
        {
            "name": "Revetment height",
            "value": "7.5m"
        },
        {
            "name": "Slope",
            "value": "2H:1V top - 1.5H:1V main"
        },
        {
            "name": "Main layer thickness",
            "value": "1.44m"
        },
        {
            "name": "Underlayer thickness",
            "value": "Variable"
        },
        {
            "name": "Toe berm width",
            "value": "2.0m"
        },
        {
            "name": "Toe berm thickness",
            "value": "1.2m"
        },
        {
            "name": "Kerb dimensions",
            "value": "600 x 300 mm"
        }
    ]
},
    //Maritime card for Ma.Maritime.Revetments.Rockrevetment-18m.Rock
    {
    "id": "Ma.Maritime.Revetments.Rockrevetment-18m.Rock",
    "name": "Rock revetment - 18m",
    "subtitle": "Rock revetment - 18m height",
    "category": "Maritime",
    "subCategory": "Revetments",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 3157.5,
    "A4": 1000.5,
    "A5": 415.8,
    "totalCarbon": 4573.9,
    "units": "kgCO2e/m",
    "description": "18m height of 2-layered 2H:1V revetment with 1-3t rock main layer and 0-500kg rock second layer of 2.00m and 1.25m thickness respectively.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Revetments",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Revetments.Rockrevetment-18m.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 3157.5
        },
        {
            "name": "Transport (A4)",
            "value": 1000.5
        },
        {
            "name": "Site activities (A5)",
            "value": 415.8
        }
    ],
    "materials": [
        {
            "name": "1-3t rock",
            "value": 3682.0
        },
        {
            "name": "0-500kg core material",
            "value": 891.9
        }
    ],
    "components": [
        {
            "name": "Main layer",
            "value": 3682.0
        },
        {
            "name": "Underlayer",
            "value": 891.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Revetment height",
            "value": "18.0m"
        },
        {
            "name": "Slope",
            "value": "2H:1V"
        },
        {
            "name": "Main layer thickness",
            "value": "2.00m"
        },
        {
            "name": "Underlayer thickness",
            "value": "1.25m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Revetments.Rockrevetment-10m.Rock
    {
    "id": "Ma.Maritime.Revetments.Rockrevetment-10m.Rock",
    "name": "Rock revetment - 10m",
    "subtitle": "Rock revetment - 10m height",
    "category": "Maritime",
    "subCategory": "Revetments",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Rock",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 1839.1,
    "A4": 574.1,
    "A5": 241.3,
    "totalCarbon": 2654.6,
    "units": "kgCO2e/m",
    "description": "10m height of 2-layered 2H:1V revetment with 1-3t rock main layer and 0-500kg rock second layer of 2.00m and 1.25m thickness respectively. Includes geotextil",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Revetments",
        "Rock",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Revetments.Rockrevetment-10m.Rock.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 1839.1
        },
        {
            "name": "Transport (A4)",
            "value": 574.1
        },
        {
            "name": "Site activities (A5)",
            "value": 241.3
        }
    ],
    "materials": [
        {
            "name": "1-3t rock",
            "value": 2167.8
        },
        {
            "name": "0-500kg core material",
            "value": 486.9
        }
    ],
    "components": [
        {
            "name": "Main layer",
            "value": 2167.8
        },
        {
            "name": "Underlayer",
            "value": 486.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Revetment height",
            "value": "10.5m"
        },
        {
            "name": "Slope",
            "value": "2H:1V"
        },
        {
            "name": "Main layer thickness",
            "value": "2.00m"
        },
        {
            "name": "Underlayer thickness",
            "value": "1.25m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Quaywalls.Gravitywall-10m.Concrete
    {
    "id": "Ma.Maritime.Quaywalls.Gravitywall-10m.Concrete",
    "name": "Gravity wall - 10m",
    "subtitle": "Concrete blocks gravity wall - 10 m (Retained height )",
    "category": "Maritime",
    "subCategory": "Quay walls",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 8593.4,
    "A4": 4147.7,
    "A5": 657.8,
    "totalCarbon": 13398.9,
    "units": "kgCO2e/m",
    "description": "10m retained height gravity wall of 1.5x5.0m precast concrete blocks. Includes scour protection and gravel and sand bedding.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Quay walls",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Quaywalls.Gravitywall-10m.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 8593.4
        },
        {
            "name": "Transport (A4)",
            "value": 4147.7
        },
        {
            "name": "Site activities (A5)",
            "value": 657.8
        }
    ],
    "materials": [
        {
            "name": "Concrete RC25/30 with 70% GGBS cement",
            "value": 11736.3
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 1206.4
        },
        {
            "name": "60-300kg rock",
            "value": 255.6
        },
        {
            "name": "Type 1 fill material ",
            "value": 200.7
        }
    ],
    "components": [
        {
            "name": "Concrete blocks",
            "value": 10979.7
        },
        {
            "name": "Capping beam",
            "value": 1206.4
        },
        {
            "name": "Rock bedding",
            "value": 255.6
        },
        {
            "name": "Gravel bedding",
            "value": 200.7
        },
        {
            "name": "Scour protection",
            "value": 756.5
        }
    ],
    "designAssumptions": [
        {
            "name": "Concrete blocks dimensions",
            "value": "1.5 x 5.0m"
        },
        {
            "name": "Retained height",
            "value": "10.0m"
        },
        {
            "name": "Gravel bedding thickness",
            "value": "0.2m"
        },
        {
            "name": "Gravel bedding width",
            "value": "8.5m"
        },
        {
            "name": "Rock bedding thickness",
            "value": "1.3m"
        },
        {
            "name": "Rock bedding width",
            "value": "8.5m"
        },
        {
            "name": "Underlayer width",
            "value": "12.5m"
        },
        {
            "name": "Scour protection width",
            "value": "10.0m"
        },
        {
            "name": "Scour protection thickness",
            "value": "0.3m"
        },
        {
            "name": "Concrete beam dimensions",
            "value": "3.0 x 1.5m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Quaywalls.Sheetpile-10m.Steel
    {
    "id": "Ma.Maritime.Quaywalls.Sheetpile-10m.Steel",
    "name": "Sheet pile - 10m",
    "subtitle": "Sheet piled quay wall - 10 m (Retained height )",
    "category": "Maritime",
    "subCategory": "Quay walls",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 24690.0,
    "A4": 586.0,
    "A5": 327.5,
    "totalCarbon": 25603.6,
    "units": "kgCO2e/m",
    "description": "10m retained height sheet piled wall with 20m total height, of AZ41-700. Anchor wall of 5m height of AZ20-700.  Use of tie rods M60, of 60mm diameter, spaced at every 2.8m. Scour protection with concrete matresses, 10m wide and 300mm deep.",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Maritime",
        "Quay walls",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Quaywalls.Sheetpile-10m.Steel.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 24690.0
        },
        {
            "name": "Transport (A4)",
            "value": 586.0
        },
        {
            "name": "Site activities (A5)",
            "value": 327.5
        }
    ],
    "materials": [
        {
            "name": "Steel Section",
            "value": 23640.7
        },
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 1206.4
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 756.5
        }
    ],
    "components": [
        {
            "name": "Sheet pile",
            "value": 7289.0
        },
        {
            "name": "Concrete capping beam",
            "value": 1206.4
        },
        {
            "name": "Scour protection",
            "value": 756.5
        },
        {
            "name": "Anchor system",
            "value": 16351.8
        }
    ],
    "designAssumptions": [
        {
            "name": "Sheet pile retained height",
            "value": "10.0m"
        },
        {
            "name": "Sheet pile total height",
            "value": "20.0m"
        },
        {
            "name": "Anchor sheet pile height",
            "value": "5.0m"
        },
        {
            "name": "Anchor diameter",
            "value": "60mm"
        },
        {
            "name": "Anchor length",
            "value": "24.5 m"
        },
        {
            "name": "Anchor spacement",
            "value": "2.8m"
        },
        {
            "name": "Concrete beam dimensions",
            "value": "3.0 x 1.5m"
        },
        {
            "name": "Scour protection width",
            "value": "10.0m"
        },
        {
            "name": "Scour protection thickness",
            "value": "0.3m"
        }
    ]
},
    //Maritime card for Ma.Maritime.Quaywalls.Combiwall.Concrete
    {
    "id": "Ma.Maritime.Quaywalls.Combiwall.Concrete",
    "name": "Combi wall -18m",
    "subtitle": "Combi - wall for quays - 18m (Retained height )",
    "category": "Maritime",
    "subCategory": "Quay walls ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 74224.1,
    "A4": 1879.4,
    "A5": 1293.7,
    "totalCarbon": 77397.3,
    "units": "kgCO2e/m",
    "description": "18m retained height combi wall with 36m total height of wall. Main wall tubular piles: 1620mm diameter and 18mm thickness and Infill piles: LX32 corus section. Anchor wall tubular piles: 1420mm and 14mm thickness and Infill piles: Nr6 (138.7). Use of 2 tie rods per pile, 2 M95, of 95mm diameter. Scour protection with concrete matresses, 20m wide and 300mm deep.",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Maritime",
        "Quay walls ",
        "Concrete ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Quaywalls.Combiwall.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 74224.1
        },
        {
            "name": "Transport (A4)",
            "value": 1879.4
        },
        {
            "name": "Site activities (A5)",
            "value": 1293.7
        }
    ],
    "materials": [
        {
            "name": "Steel tube ",
            "value": 39278.9
        },
        {
            "name": "Steel Section",
            "value": 19599.2
        },
        {
            "name": "Steel tie trods /anchoring bars ",
            "value": 4535.4
        },
        {
            "name": "In situ - Concrete RC 40/50 with 50% GGBS cement",
            "value": 10582.0
        },
        {
            "name": "Precast - Concrete RC 40/50 with 50% GGBS cement",
            "value": 1888.7
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 1513.1
        }
    ],
    "components": [
        {
            "name": "Main wall ",
            "value": 47092.7
        },
        {
            "name": "Anchor wall",
            "value": 22367.5
        },
        {
            "name": "Capping beam ",
            "value": 1888.7
        },
        {
            "name": "Tie rods",
            "value": 4535.4
        },
        {
            "name": "Scour protection",
            "value": 1513.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained Height ",
            "value": "18m"
        },
        {
            "name": "Main wall tubular piles ",
            "value": "1620mm diameter and 18mm thickness"
        },
        {
            "name": "Main wall infill piles  ",
            "value": "LX32"
        },
        {
            "name": "Anchor wall tubular piles ",
            "value": "1420mm diameter and 14mm thickness"
        },
        {
            "name": "Anchor wall infill piles",
            "value": "Nr.6 (138.7)"
        },
        {
            "name": "Tie rods ",
            "value": "2 M 95 per pile "
        },
        {
            "name": "Capping beam ",
            "value": "3.3m * 3.3 m"
        },
        {
            "name": "Scour protection ",
            "value": "Concrete matresses- 20m wide and 0.3m deep layer  "
        }
    ]
},
    //Maritime card for Ma.Maritime.Quaywalls.Caissons-18m-width15.5.Dredgedfillmaterial
    {
    "id": "Ma.Maritime.Quaywalls.Caissons-18m-width15.5.Dredgedfillmaterial",
    "name": "Caissons - 18m x 15.5m",
    "subtitle": "Caissons -18m (retained height ) and 15.5m caisson width ",
    "category": "Maritime",
    "subCategory": "Quay walls ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Dredged fill material ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 49831.5,
    "A4": 5874.6,
    "A5": 3291.0,
    "totalCarbon": 58997.2,
    "units": "kgCO2e/m",
    "description": "Caissons -18m (retained height ), and 15.5m caisson width, Internal walls 250mm thick and\nExternal walls 500mm thick. Scour protection with concrete matresses, 20m wide and 300mm deep.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Quay walls ",
        "Dredged fill material ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Quaywalls.Caissons-18m-width15.5.Dredgedfillmaterial.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 49831.5
        },
        {
            "name": "Transport (A4)",
            "value": 5874.6
        },
        {
            "name": "Site activities (A5)",
            "value": 3291.0
        }
    ],
    "materials": [
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 21643.6
        },
        {
            "name": "Dredged material from maritime construction site",
            "value": 4510.3
        },
        {
            "name": "Steel Rebar",
            "value": 29219.7
        },
        {
            "name": "Type 1 fill material ",
            "value": 5718.8
        },
        {
            "name": "60-300kg rock",
            "value": 896.5
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 1513.1
        }
    ],
    "components": [
        {
            "name": "Caissons",
            "value": 43731.3
        },
        {
            "name": "Fill inside caissons",
            "value": 4510.3
        },
        {
            "name": "Capping beam ",
            "value": 2627.2
        },
        {
            "name": "Fill above caissons below pavement",
            "value": 4846.7
        },
        {
            "name": "Bedding",
            "value": 1768.6
        },
        {
            "name": "Scour protection ",
            "value": 1513.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained Height ",
            "value": "18m"
        },
        {
            "name": "Caissons dimensions",
            "value": "Length=50m,  Width=15.5m,  3 series chambers"
        },
        {
            "name": "Fill material",
            "value": "Dredged from the construction site"
        },
        {
            "name": "Reiforcement density ",
            "value": "300 kg/m^3"
        },
        {
            "name": "Concrete capping beam ",
            "value": "6.4 m total width ( covering up to the first chamber width) and 2 m deep."
        },
        {
            "name": "Filling area on top of caissons",
            "value": "Use of Type 1 fill to cover area from the top part of caissons up to the lower surface of the quay pavings. "
        },
        {
            "name": "Top bedding layer ",
            "value": "Type 1 fill material and 200mm thickness layer"
        },
        {
            "name": "Bottom bedding layer ",
            "value": "Use of 60-300 kg rock and 1300mm thickness layer"
        },
        {
            "name": "Scour Protection ",
            "value": "Concrete matresses- 20m wide and 0.3m deep layer  "
        },
        {
            "name": "External walls ",
            "value": "500mm thick"
        },
        {
            "name": "Internal wall ",
            "value": "250mm thick"
        }
    ]
},
    //Maritime card for Ma.Maritime.Quaywalls.Caissons-18mwidth12m.Dredgedfillmaterial
    {
    "id": "Ma.Maritime.Quaywalls.Caissons-18mwidth12m.Dredgedfillmaterial",
    "name": "Caissons - 18m x 12m ",
    "subtitle": "Caissons - 18m (retained height ) and 12m caisson width ",
    "category": "Maritime",
    "subCategory": "Quay walls ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Dredged fill material ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 42995.2,
    "A4": 4846.1,
    "A5": 2770.1,
    "totalCarbon": 50611.5,
    "units": "kgCO2e/m",
    "description": "Caissons -18m (retained height ) and 12m caisson width,  Internal walls 250mm thick and\nExternal walls 500mm thick. Scour protection with concrete matresses, 20m wide and 300mm deep.",
    "references": [
        "Quantifying the carbon footprint of coastal construction, a new tool HRCAT. ICE Coastal Management Conference 2011, November 2011, Belfast"
    ],
    "tags": [
        "Maritime",
        "Quay walls ",
        "Dredged fill material ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Quaywalls.Caissons-18mwidth12m.Dredgedfillmaterial.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 42995.2
        },
        {
            "name": "Transport (A4)",
            "value": 4846.1
        },
        {
            "name": "Site activities (A5)",
            "value": 2770.1
        }
    ],
    "materials": [
        {
            "name": "Concrete RC40/50 with 50% GGBS cement",
            "value": 19750.8
        },
        {
            "name": "Dredged material from maritime construction site",
            "value": 3468.0
        },
        {
            "name": "Steel Rebar",
            "value": 25534.1
        },
        {
            "name": "Type 1 fill material ",
            "value": 4226.2
        },
        {
            "name": "60-300kg rock",
            "value": 624.2
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 1513.1
        }
    ],
    "components": [
        {
            "name": "Caissons",
            "value": 38152.8
        },
        {
            "name": "Fill inside caissons",
            "value": 3468.0
        },
        {
            "name": "Capping beam ",
            "value": 2627.2
        },
        {
            "name": "Fill above caissons below pavement",
            "value": 3471.5
        },
        {
            "name": "Bedding",
            "value": 1378.9
        },
        {
            "name": "Scour protection ",
            "value": 1513.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained Height ",
            "value": "18m"
        },
        {
            "name": "Caissons dimensions",
            "value": "Length=50m,  Width=12m,  2 series chambers"
        },
        {
            "name": "Fill material",
            "value": "Dredged from the construction site"
        },
        {
            "name": "Reiforcement density ",
            "value": "300 kg/m^3"
        },
        {
            "name": "Concrete capping beam ",
            "value": "6.4 m total width ( covering up to the first chamber width) and 2 m deep."
        },
        {
            "name": "Filling area on top of caissons",
            "value": "Use of Type 1 fill to cover area from the top part of caissons up to the lower surface of the quay pavings. "
        },
        {
            "name": "Top bedding layer ",
            "value": "Type 1 fill material and 200mm thickness layer"
        },
        {
            "name": "Bottom bedding layer ",
            "value": "Use of 60-300 kg rock and 1300mm thickness layer"
        },
        {
            "name": "Scour Protection ",
            "value": "Concrete matresses- 20m wide and 0.3m deep layer  "
        },
        {
            "name": "External walls ",
            "value": "500mm thick"
        },
        {
            "name": "Internal wall ",
            "value": "250mm thick"
        }
    ]
},
    //Maritime card for Ma.Maritime.Suspendeddeck.Suspendeddeck-10m.Concrete
    {
    "id": "Ma.Maritime.Suspendeddeck.Suspendeddeck-10m.Concrete",
    "name": "Suspended deck - 10m",
    "subtitle": "Suspended deck - 10m (retained height)",
    "category": "Maritime",
    "subCategory": "Suspended deck ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 13360.9,
    "A4": 649.8,
    "A5": 508.0,
    "totalCarbon": 15999.3,
    "units": "kgCO2e/m",
    "description": "Suspended deck quay structure with 10m retained height, 660mm diameter and 16mm thickness tubular piles, in 6m pile grid. Cut-off sheet pile  AZ18. Scour protection with matresses: 10m width of layer on the flat bed surface and 300mm deep, and 16.5m width of layer on the sloped bed surface and 300mm deep.",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Maritime",
        "Suspended deck ",
        "Concrete ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Suspendeddeck.Suspendeddeck-10m.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 13360.9
        },
        {
            "name": "Transport (A4)",
            "value": 649.8
        },
        {
            "name": "Site activities (A5)",
            "value": 508.0
        }
    ],
    "materials": [
        {
            "name": "In situ - Concrete RC 40/50 with 50% GGBS cement",
            "value": 1769.8
        },
        {
            "name": "Precast - Concrete RC 40/50 with 50% GGBS cement",
            "value": 1613.3
        },
        {
            "name": "Steel Rebar",
            "value": 3881.7
        },
        {
            "name": "Steel tube ",
            "value": 5980.7
        },
        {
            "name": "Steel Section",
            "value": 748.9
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 2004.9
        }
    ],
    "components": [
        {
            "name": "Deck ",
            "value": 7130.8
        },
        {
            "name": "Tubular piles",
            "value": 5980.7
        },
        {
            "name": "Cut-of sheet pile",
            "value": 748.9
        },
        {
            "name": "Back cope beam ",
            "value": 134.0
        },
        {
            "name": "Scour Protection",
            "value": 2004.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained Height ",
            "value": "10m"
        },
        {
            "name": "Reinforcement density in the deck ",
            "value": "150 kg/m^3"
        },
        {
            "name": "Tubular piles ",
            "value": "660mm diameter and 16mm thickness, in 6m pile grid "
        },
        {
            "name": "Cut-off sheet pile ",
            "value": "AZ18"
        },
        {
            "name": "Back cope beam - on top of cut-off wall",
            "value": "1m width and 0.5m deep"
        },
        {
            "name": "Scour protection ",
            "value": "10 m width of scour protection on the flat bed surface and 16.5m width of scour protection covering the sloped bed up to the cut-off wall. Concrete matresses to be used forming a 0.3m scour protection layer"
        }
    ]
},
    //Maritime card for Ma.Maritime.Suspendeddeck.Suspendeddeck-18m.Concrete
    {
    "id": "Ma.Maritime.Suspendeddeck.Suspendeddeck-18m.Concrete",
    "name": "Suspended deck - 18m",
    "subtitle": "Suspended deck -18 m (retained height)",
    "category": "Maritime",
    "subCategory": "Suspended deck ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 49177.1,
    "A4": 1483.8,
    "A5": 1238.3,
    "totalCarbon": 51899.3,
    "units": "kgCO2e/m",
    "description": "Suspended deck quay structure with 18m retained height, 914mm diameter and 20mm thickness tubular piles, in 6m pile grid. Cut-off sheet pile  AZ18. Scour protection with matresses: 20m width of layer on the flat bed surface and 300mm deep, and 33.8m width of layer on the sloped bed surface and 300mm deep.",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Maritime",
        "Suspended deck ",
        "Concrete ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Suspendeddeck.Suspendeddeck-18m.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 49177.1
        },
        {
            "name": "Transport (A4)",
            "value": 1483.8
        },
        {
            "name": "Site activities (A5)",
            "value": 1238.3
        }
    ],
    "materials": [
        {
            "name": "In situ - Concrete RC 40/50 with 50% GGBS cement",
            "value": 3645.3
        },
        {
            "name": "Precast - Concrete RC 40/50 with 50% GGBS cement",
            "value": 3198.6
        },
        {
            "name": "Steel Rebar",
            "value": 8294.3
        },
        {
            "name": "Steel tube ",
            "value": 31193.2
        },
        {
            "name": "Steel Section",
            "value": 1497.7
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 4070.2
        }
    ],
    "components": [
        {
            "name": "Deck ",
            "value": 14977.4
        },
        {
            "name": "Tubular piles",
            "value": 31193.2
        },
        {
            "name": "Cut-of sheet pile",
            "value": 1497.7
        },
        {
            "name": "Back cope beam ",
            "value": 160.9
        },
        {
            "name": "Scour Protection ",
            "value": 4070.2
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained Height ",
            "value": "18m"
        },
        {
            "name": "Reinforcement density in the deck ",
            "value": "150 kg/m^3"
        },
        {
            "name": "Tubular piles ",
            "value": "914mm diameter and 20mm thickness, in 6m pile grid "
        },
        {
            "name": "Cut-off sheet pile ",
            "value": "AZ18"
        },
        {
            "name": "Back cope beam - on top of cut-off wall",
            "value": "1.2m width and 0.5m deep"
        },
        {
            "name": "Scour protection ",
            "value": "20 m width of scour protection on the flat bed surface and 33.8m width of scour protection covering the sloped bed up to the cut-off wall. Concrete matresses to be used forming a 0.3m scour protection layer"
        }
    ]
},
    //Maritime card for Ma.Maritime.Diaphragmwall.Diaphragmwall-RetainedHeight27m.Concrete
    {
    "id": "Ma.Maritime.Diaphragmwall.Diaphragmwall-RetainedHeight27m.Concrete",
    "name": "Diaphragm wall - 27m ",
    "subtitle": "Diaphragm wall for quays  - 27m ( Retained Height)",
    "category": "Maritime",
    "subCategory": "Diaphragm wall ",
    "sector": "Transport",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete ",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 108560.7,
    "A4": 3486.4,
    "A5": 5454.3,
    "totalCarbon": 117501.5,
    "units": "kgCO2e/m",
    "description": "27m retained height diaphragm wall with 47m total height of the wall, and 1.5m width. Anchor wall of about 28m total height, and 1m width. Use of tie rods such as ASDO 500 M155, of 155mm diameter, spaced at every at every 2.5m. Scour protection with concrete matresses, 20m wide and 300mm deep.",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Maritime",
        "Diaphragm wall ",
        "Concrete ",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Isobel McClure",
        "Kyriakos Chomatas",
        "Emilio Laino"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/Ma.Maritime.Diaphragmwall.Diaphragmwall-RetainedHeight27m.Concrete.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 108560.7
        },
        {
            "name": "Transport (A4)",
            "value": 3486.4
        },
        {
            "name": "Site activities (A5)",
            "value": 5454.3
        }
    ],
    "materials": [
        {
            "name": "In situ - Concrete RC 40/50 with 50% GGBS cement",
            "value": 26185.7
        },
        {
            "name": "Precast - Concrete RC 40/50 with 50% GGBS cement",
            "value": 3963.6
        },
        {
            "name": "Steel Rebar",
            "value": 62956.1
        },
        {
            "name": "Bentonite slurry",
            "value": 19146.2
        },
        {
            "name": "Steel tie trods /anchoring bars ",
            "value": 3736.9
        },
        {
            "name": "Concrete RC28/35 with 50% GGBS cement",
            "value": 1513.1
        }
    ],
    "components": [
        {
            "name": "Main wall ",
            "value": 76762.2
        },
        {
            "name": "Capping beam main wall ",
            "value": 3073.1
        },
        {
            "name": "Anchor Wall",
            "value": 31525.6
        },
        {
            "name": "Capping beam anchor wall ",
            "value": 890.4
        },
        {
            "name": "Tie rods",
            "value": 3736.9
        },
        {
            "name": "Scour Protection ",
            "value": 1513.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained height ",
            "value": "27m"
        },
        {
            "name": "Main wall dimensions",
            "value": "Width =1.5m and Total Height =47m"
        },
        {
            "name": "Main wall capping beam ",
            "value": "Width =5m and Depth=2m"
        },
        {
            "name": "Anchor wall dimensions",
            "value": "Width =1m and Total Height =28m"
        },
        {
            "name": "Anchor wall capping beam ",
            "value": "Width =2.5m and Depth=1m"
        },
        {
            "name": "Tie rods ",
            "value": "Use of ASDO 500 M155, diameter 155 mm and spacing at every 2.5m"
        },
        {
            "name": "Bentonite slurry ( stabilisation liquid)",
            "value": "20% of the volume of concrete in both the main and anchor diaphragm wall"
        },
        {
            "name": "Scour protection",
            "value": "Concrete matresses- 20m wide and 0.3m deep layer  "
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip850mm
    {
    "id": "GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip850mm",
    "name": "Traditional strip foundation",
    "subtitle": "Strip width 850mm",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 80.3,
    "A4": 11.4,
    "A5": 2.1,
    "totalCarbon": 93.8,
    "units": "kgCO2e/m strip length",
    "description": "Unitised traditional strip footing, no steel reinforcement. Assuming wall and footing thickness of 275mm (wall embodied carbon not included), excavation depth of 700mm and granular backfill of excavation.",
    "references": [
        "ICE Database v3.0b 2019",
        "HM Government (2013) Approved Document A: The Building Regulations 2010 Structure"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip850mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 80.3
        },
        {
            "name": "Transport (A4)",
            "value": 11.4
        },
        {
            "name": "Site activities (A5)",
            "value": 2.1
        }
    ],
    "materials": [
        {
            "name": "Soil waste",
            "value": 6.1
        },
        {
            "name": "Aggregates and sand, general UK",
            "value": 5.8
        },
        {
            "name": "Concrete",
            "value": 81.9
        }
    ],
    "components": [
        {
            "name": "Concrete foundation",
            "value": 81.9
        },
        {
            "name": "Excavation / backfill",
            "value": 11.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Strip width",
            "value": "850mm"
        },
        {
            "name": "Strip thickness",
            "value": "275mm"
        },
        {
            "name": "Depth to foundation base",
            "value": "750mm"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": "None"
        },
        {
            "name": "Wall thickness",
            "value": "275mm - materials not included"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "n/a"
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip1050mm
    {
    "id": "GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip1050mm",
    "name": "Traditional strip foundation",
    "subtitle": "Strip width 1050mm",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 168.1,
    "A4": 20.4,
    "A5": 5.4,
    "totalCarbon": 194.0,
    "units": "kgCO2e/m strip length",
    "description": "Unitised traditional strip footing, 2% steel reinforcement. Assuming wall and footing thickness of 350mm (wall embodied carbon not included), excavation depth of 1000mm and granular backfill of excavation.",
    "references": [
        "ICE Database v3.0b 2019",
        "HM Government (2013) Approved Document A: The Building Regulations 2010 Structure"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Rebar",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip1050mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 168.1
        },
        {
            "name": "Transport (A4)",
            "value": 20.4
        },
        {
            "name": "Site activities (A5)",
            "value": 5.4
        }
    ],
    "materials": [
        {
            "name": "Soil waste",
            "value": 10.1
        },
        {
            "name": "Aggregates and sand, general UK",
            "value": 9.8
        },
        {
            "name": "Concrete",
            "value": 126.2
        },
        {
            "name": "Steel reinforcement",
            "value": 47.9
        }
    ],
    "components": [
        {
            "name": "Concrete foundation",
            "value": 174.2
        },
        {
            "name": "Excavation / backfill",
            "value": 19.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Strip width",
            "value": "1050mm"
        },
        {
            "name": "Strip thickness",
            "value": "350mm"
        },
        {
            "name": "Depth to foundation base",
            "value": "1000mm"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.02
        },
        {
            "name": "Wall thickness",
            "value": "350mm - materials not included"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip600mm
    {
    "id": "GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip600mm",
    "name": "Traditional strip foundation",
    "subtitle": "Strip width 600mm",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 40.8,
    "A4": 4.7,
    "A5": 1.0,
    "totalCarbon": 46.5,
    "units": "kgCO2e/m strip length",
    "description": "Unitised traditional strip footing, no steel reinforcement. Assuming wall and footing thickness of 200mm (wall embodied carbon not included), excavation depth of 450mm and granular backfill of excavation.",
    "references": [
        "ICE Database v3.0b 2019",
        "HM Government (2013) Approved Document A: The Building Regulations 2010 Structure"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip600mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 40.8
        },
        {
            "name": "Transport (A4)",
            "value": 4.7
        },
        {
            "name": "Site activities (A5)",
            "value": 1.0
        }
    ],
    "materials": [
        {
            "name": "Soil waste",
            "value": 2.3
        },
        {
            "name": "Aggregates and sand, general UK",
            "value": 2.2
        },
        {
            "name": "Concrete",
            "value": 42.1
        }
    ],
    "components": [
        {
            "name": "Concrete foundation",
            "value": 42.1
        },
        {
            "name": "Excavation / backfill",
            "value": 4.5
        }
    ],
    "designAssumptions": [
        {
            "name": "Strip width",
            "value": "600mm"
        },
        {
            "name": "Strip thickness",
            "value": "200mm"
        },
        {
            "name": "Depth to foundation base",
            "value": "450mm"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": "None"
        },
        {
            "name": "Wall thickness",
            "value": "200mm - materials not included"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "n/a"
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.RaftFoundation.UnpiledRaft1m
    {
    "id": "GT.ShallowFoundation.RaftFoundation.UnpiledRaft1m",
    "name": "Raft foundation (unpiled)",
    "subtitle": "Raft thickness 1m",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 461.0,
    "A4": 5.0,
    "A5": 14.5,
    "totalCarbon": 480.5,
    "units": "kgCO2e/m2",
    "description": "Unpiled raft foundation, 1m thick reinforced concrete raft, 2% steel reinforcement, 75mm plain concrete blinding layer. Soil excavation and disposal and backfill not included.",
    "references": [
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.RaftFoundation.UnpiledRaft1m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 461.0
        },
        {
            "name": "Transport (A4)",
            "value": 5.0
        },
        {
            "name": "Site activities (A5)",
            "value": 14.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 363.6
        },
        {
            "name": "Steel reinforcement",
            "value": 130.3
        }
    ],
    "components": [
        {
            "name": "Reinforced concrete raft",
            "value": 473.8
        },
        {
            "name": "Plain concrete blinding layer",
            "value": 20.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Slab Thickness",
            "value": "1m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.02
        },
        {
            "name": "Blinding layer thickness",
            "value": "75mm"
        },
        {
            "name": "Temporary works",
            "value": "Not included"
        },
        {
            "name": "Hardcore Underlayer",
            "value": "Not included"
        },
        {
            "name": "Raft concrete",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Blinding concrete",
            "value": "Concrete Gen 3 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "World average steel (ICE, 2019)"
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.RaftFoundation.UnpiledRaft2m
    {
    "id": "GT.ShallowFoundation.RaftFoundation.UnpiledRaft2m",
    "name": "Raft foundation (unpiled)",
    "subtitle": "Raft thickness 2m",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 903.3,
    "A4": 10.0,
    "A5": 28.5,
    "totalCarbon": 941.9,
    "units": "kgCO2e/m2",
    "description": "Unpiled raft foundation, 2m thick reinforced concrete raft, 2% steel reinforcement, 75mm plain concrete blinding layer. Soil excavation and disposal and backfill not included.",
    "references": [
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.RaftFoundation.UnpiledRaft2m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 903.3
        },
        {
            "name": "Transport (A4)",
            "value": 10.0
        },
        {
            "name": "Site activities (A5)",
            "value": 28.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 707.1
        },
        {
            "name": "Steel reinforcement",
            "value": 260.5
        }
    ],
    "components": [
        {
            "name": "Reinforced concrete raft",
            "value": 947.7
        },
        {
            "name": "Plain concrete blinding layer",
            "value": 20.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Slab Thickness",
            "value": "2m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.02
        },
        {
            "name": "Blinding layer thickness",
            "value": "75mm"
        },
        {
            "name": "Temporary works",
            "value": "Not included"
        },
        {
            "name": "Hardcore Underlayer",
            "value": "Not included"
        },
        {
            "name": "Raft concrete",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Blinding concrete",
            "value": "Concrete Gen 3 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "World average steel (ICE, 2019)"
        }
    ]
},
    //Geotechnics card for GT.ShallowFoundation.RaftFoundation.UnpiledRaft1-5m
    {
    "id": "GT.ShallowFoundation.RaftFoundation.UnpiledRaft1-5m",
    "name": "Raft foundation (unpiled)",
    "subtitle": "Raft thickness 1.5m",
    "category": "Geotechnics",
    "subCategory": "Shallow foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 682.1,
    "A4": 7.5,
    "A5": 21.5,
    "totalCarbon": 711.2,
    "units": "kgCO2e/m2",
    "description": "Unpiled raft foundation, 1.5m thick reinforced concrete raft, 2% steel reinforcement, 75mm plain concrete blinding layer. Soil excavation and disposal and backfill not included.",
    "references": [
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Foundation",
        "Shallow foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.ShallowFoundation.RaftFoundation.UnpiledRaft1-5m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 682.1
        },
        {
            "name": "Transport (A4)",
            "value": 7.5
        },
        {
            "name": "Site activities (A5)",
            "value": 21.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 535.4
        },
        {
            "name": "Steel reinforcement",
            "value": 195.4
        }
    ],
    "components": [
        {
            "name": "Reinforced concrete raft",
            "value": 710.8
        },
        {
            "name": "Plain concrete blinding layer",
            "value": 20.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Slab Thickness",
            "value": "1.5m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.02
        },
        {
            "name": "Blinding layer thickness",
            "value": "75mm"
        },
        {
            "name": "Temporary works",
            "value": "Not included"
        },
        {
            "name": "Hardcore Underlayer",
            "value": "Not included"
        },
        {
            "name": "Raft concrete",
            "value": "Concrete RC32/40 with average UK additions cement"
        },
        {
            "name": "Blinding concrete",
            "value": "Concrete Gen 3 with average UK additions cement"
        },
        {
            "name": "Reinforcement type",
            "value": "World average steel (ICE, 2019)"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle600dia
    {
    "id": "GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle600dia",
    "name": "Rotary bored pile",
    "subtitle": "Single pile 600mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 1722.4,
    "A4": 96.3,
    "A5": 156.6,
    "totalCarbon": 1975.3,
    "units": "kgCO2e/pile",
    "description": "Single cast insitu rotary bored pile. Diameter of 0.6m, length of 20m. Assuming 1% steel reinforcement by volume, pilecap constructed on top of pile, and removal of soil arisings from site.",
    "references": [
        "ICE Database v3.0b 2019",
        "IStructE, How to calculate embodied carbon, 2020"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle600dia.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 1722.4
        },
        {
            "name": "Transport (A4)",
            "value": 96.3
        },
        {
            "name": "Site activities (A5)",
            "value": 156.6
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 1497.2
        },
        {
            "name": "Soil waste",
            "value": 60.2
        },
        {
            "name": "Steel reinforcement",
            "value": 417.9
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 1696.4
        },
        {
            "name": "Pilecap",
            "value": 218.7
        },
        {
            "name": "Pile arisings",
            "value": 60.2
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "0.6m"
        },
        {
            "name": "Pile length",
            "value": "20m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "0.9 x 0.9 x 0.9m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Support fluid",
            "value": "None - pile bored dry"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle900dia
    {
    "id": "GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle900dia",
    "name": "Rotary bored pile",
    "subtitle": "Single pile 900mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 4757.2,
    "A4": 265.9,
    "A5": 435.6,
    "totalCarbon": 5458.8,
    "units": "kgCO2e/pile",
    "description": "Single cast insitu rotary bored pile. Diameter of 0.9m, length of 25m. Assuming 1% steel reinforcement by volume, pilecap constructed on top of pile, and removal of soil arisings from site.",
    "references": [
        "ICE Database v3.0b 2019",
        "IStructE, How to calculate embodied carbon, 2020"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle900dia.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 4757.2
        },
        {
            "name": "Transport (A4)",
            "value": 265.9
        },
        {
            "name": "Site activities (A5)",
            "value": 435.6
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 4135.1
        },
        {
            "name": "Soil waste",
            "value": 169.4
        },
        {
            "name": "Steel reinforcement",
            "value": 1154.2
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 4771.0
        },
        {
            "name": "Pilecap",
            "value": 518.4
        },
        {
            "name": "Pile arisings",
            "value": 169.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "0.9m"
        },
        {
            "name": "Pile length",
            "value": "25m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "1.2 x 1.2 x 1.2m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Support fluid",
            "value": "None - pile bored dry"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1200dia
    {
    "id": "GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1200dia",
    "name": "Rotary bored pile",
    "subtitle": "Single pile 1200mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 10064.8,
    "A4": 562.6,
    "A5": 924.6,
    "totalCarbon": 11551.9,
    "units": "kgCO2e/pile",
    "description": "Single cast insitu rotary bored pile. Diameter of 1.2m, length of 30m. Assuming 1% steel reinforcement by volume, pilecap constructed on top of pile, and removal of soil arisings from site.",
    "references": [
        "ICE Database v3.0b 2019",
        "IStructE, How to calculate embodied carbon, 2020"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1200dia.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 10064.8
        },
        {
            "name": "Transport (A4)",
            "value": 562.6
        },
        {
            "name": "Site activities (A5)",
            "value": 924.6
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 8748.5
        },
        {
            "name": "Soil waste",
            "value": 361.3
        },
        {
            "name": "Steel reinforcement",
            "value": 2442.1
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 10178.2
        },
        {
            "name": "Pilecap",
            "value": 1012.5
        },
        {
            "name": "Pile arisings",
            "value": 361.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "1.2m"
        },
        {
            "name": "Pile length",
            "value": "30m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "1.5 x 1.5 x 1.5m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Support fluid",
            "value": "None - pile bored dry"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1500dia
    {
    "id": "GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1500dia",
    "name": "Rotary bored pile",
    "subtitle": "Single pile 1500mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 18260.8,
    "A4": 1020.7,
    "A5": 1680.6,
    "totalCarbon": 20962.1,
    "units": "kgCO2e/pile",
    "description": "Single cast insitu rotary bored pile. Diameter of 1.5m, length of 35m. Assuming 1% steel reinforcement by volume, pilecap constructed on top of pile, and removal of soil arisings from site.",
    "references": [
        "ICE Database v3.0b 2019",
        "IStructE, How to calculate embodied carbon, 2020"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1500dia.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 18260.8
        },
        {
            "name": "Transport (A4)",
            "value": 1020.7
        },
        {
            "name": "Site activities (A5)",
            "value": 1680.6
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 15872.8
        },
        {
            "name": "Soil waste",
            "value": 658.7
        },
        {
            "name": "Steel reinforcement",
            "value": 4430.7
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 18554.0
        },
        {
            "name": "Pilecap",
            "value": 1749.6
        },
        {
            "name": "Pile arisings",
            "value": 658.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "1.5m"
        },
        {
            "name": "Pile length",
            "value": "35m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "1.8 x 1.8 x 1.8m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Support fluid",
            "value": "None - pile bored dry"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1800dia
    {
    "id": "GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1800dia",
    "name": "Rotary bored pile",
    "subtitle": "Single pile 1800mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 29961.2,
    "A4": 1674.7,
    "A5": 2760.7,
    "totalCarbon": 34396.7,
    "units": "kgCO2e/pile",
    "description": "Single cast insitu rotary bored pile. Diameter of 1.8m, length of 40m. Assuming 1% steel reinforcement by volume, pilecap constructed on top of pile, and removal of soil arisings from site.",
    "references": [
        "ICE Database v3.0b 2019",
        "IStructE, How to calculate embodied carbon, 2020"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1800dia.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 29961.2
        },
        {
            "name": "Transport (A4)",
            "value": 1674.7
        },
        {
            "name": "Site activities (A5)",
            "value": 2760.7
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 26043.0
        },
        {
            "name": "Soil waste",
            "value": 1084.0
        },
        {
            "name": "Steel reinforcement",
            "value": 7269.6
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 30534.5
        },
        {
            "name": "Pilecap",
            "value": 2778.1
        },
        {
            "name": "Pile arisings",
            "value": 1084.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "1.8m"
        },
        {
            "name": "Pile length",
            "value": "40m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "2.1 x 2.1 x 2.1m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Support fluid",
            "value": "None - pile bored dry"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.Earthworks.Cut.Reused
    {
    "id": "GT.Earthworks.Cut.Reused",
    "name": "Earthworks Cut",
    "subtitle": "Material reused on site",
    "category": "Geotechnics",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "-",
    "region": "UK",
    "carbonDatabase": "",
    "A1-3": 0.0,
    "A4": 0.0,
    "A5": 2.0,
    "totalCarbon": 2.0,
    "units": "kgCO2e/m3",
    "description": "Earthworks cut activity assuming the use of two excavators (Cat325), a dozer (Cat D7) and an ADT (Bell 30 )on site, 100% of cut reused on site",
    "references": [
        "CO2ST (Arup, 2017)",
        "Caterpillar Performance Handbook, January 2016"
    ],
    "tags": [
        "Earthworks",
        "Cut",
        "Soil",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.Earthworks.Cut.Reused.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 0.0
        },
        {
            "name": "Transport (A4)",
            "value": 0.0
        },
        {
            "name": "Site activities (A5)",
            "value": 2.0
        }
    ],
    "materials": [
        {
            "name": "Diesel",
            "value": 2.0
        }
    ],
    "components": [
        {
            "name": "Excavator",
            "value": 0.4
        },
        {
            "name": "Dozer",
            "value": 0.6
        },
        {
            "name": "ADT",
            "value": 1.0
        }
    ],
    "designAssumptions": [
        {
            "name": "A5 site activities",
            "value": "Included"
        },
        {
            "name": "Emissions per litre of diesel",
            "value": "2.762 kgCO2/l"
        },
        {
            "name": "Excavator fuel use",
            "value": "20 l/hr"
        },
        {
            "name": "ADT fuel use",
            "value": "29 l/hr"
        },
        {
            "name": "ADT haulage volume",
            "value": "15 m3"
        },
        {
            "name": "ADT Speed",
            "value": "6 km/hr"
        },
        {
            "name": "Distance to central storage facility",
            "value": "0.5 km"
        },
        {
            "name": "Bulking factor",
            "value": 1.1
        }
    ]
},
    //Geotechnics card for GT.Earthworks.Fill.Reused
    {
    "id": "GT.Earthworks.Fill.Reused",
    "name": "Earthworks Fill",
    "subtitle": "Material reused on site",
    "category": "Geotechnics",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "-",
    "region": "UK",
    "carbonDatabase": "",
    "A1-3": 0.0,
    "A4": 0.0,
    "A5": 3.7,
    "totalCarbon": 3.7,
    "units": "kgCO2e/m3",
    "description": "Earthworks fill activity assuming the use of an excavator (Cat325), a dozer (Cat D7), an ADT (Bell 30 ) and a compacter (Cat CS45B) on site, 100% of fill recycled on site",
    "references": [
        "CO2ST (Arup, 2017)",
        "Caterpillar Performance Handbook, January 2016"
    ],
    "tags": [
        "Earthworks",
        "Fill",
        "Soil",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.Earthworks.Fill.Reused.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 0.0
        },
        {
            "name": "Transport (A4)",
            "value": 0.0
        },
        {
            "name": "Site activities (A5)",
            "value": 3.7
        }
    ],
    "materials": [
        {
            "name": "Diesel",
            "value": 3.7
        }
    ],
    "components": [
        {
            "name": "Excavator",
            "value": 0.8
        },
        {
            "name": "Dozer",
            "value": 1.4
        },
        {
            "name": "ADT",
            "value": 1.0
        },
        {
            "name": "Compactor ",
            "value": 0.5
        }
    ],
    "designAssumptions": [
        {
            "name": "A5 site activities",
            "value": "Included"
        },
        {
            "name": "General aggregate density",
            "value": "1600 kg/m3"
        },
        {
            "name": "General aggregate embodied carbon",
            "value": "0.0075 kgCO2/kg"
        },
        {
            "name": "Compaction factor",
            "value": 1.15
        },
        {
            "name": "Distance to central storage facility",
            "value": "0.5 km"
        },
        {
            "name": "ADT haulage volume",
            "value": "15 m3"
        },
        {
            "name": "ADT Speed",
            "value": "6 km/hr"
        },
        {
            "name": "Emissions per litre of diesel",
            "value": "2.762 kgCO2/l"
        },
        {
            "name": "Excavator fuel use",
            "value": "20 l/hr"
        },
        {
            "name": "Dozer fuel use",
            "value": "34.2 l/hr"
        },
        {
            "name": "Compactor fuel use",
            "value": "12.5 l/hr"
        },
        {
            "name": "ADT fuel use",
            "value": "29 l/hr"
        }
    ]
},
    //Geotechnics card for GT.Earthworks.Cut.Exported
    {
    "id": "GT.Earthworks.Cut.Exported",
    "name": "Earthworks Cut",
    "subtitle": "Material exported from site",
    "category": "Geotechnics",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "-",
    "region": "UK",
    "carbonDatabase": "",
    "A1-3": 0.0,
    "A4": 11.5,
    "A5": 2.4,
    "totalCarbon": 13.9,
    "units": "kgCO2e/m3",
    "description": "Earthworks cut activity assuming the use of two excavators (Cat325), a dozer (Cat D7) and an ADT (Bell 30 )on site",
    "references": [
        "CO2ST (Arup, 2017)",
        "Caterpillar Performance Handbook, January 2016"
    ],
    "tags": [
        "Earthworks",
        "Cut",
        "Soil",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.Earthworks.Cut.Exported.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 0.0
        },
        {
            "name": "Transport (A4)",
            "value": 11.5
        },
        {
            "name": "Site activities (A5)",
            "value": 2.4
        }
    ],
    "materials": [
        {
            "name": "Diesel",
            "value": 13.9
        }
    ],
    "components": [
        {
            "name": "Excavators",
            "value": 1.4
        },
        {
            "name": "Dozer",
            "value": 0.6
        },
        {
            "name": "ADT",
            "value": 1.0
        },
        {
            "name": "Disposal",
            "value": 11.5
        }
    ],
    "designAssumptions": [
        {
            "name": "A5 site activities",
            "value": "Included"
        },
        {
            "name": "Emissions per litre of diesel",
            "value": "2.762 kgCO2/l"
        },
        {
            "name": "Excavator fuel use",
            "value": "20 l/hr"
        },
        {
            "name": "ADT fuel use",
            "value": "29 l/hr"
        },
        {
            "name": "ADT haulage volume",
            "value": "15 m3"
        },
        {
            "name": "ADT Speed",
            "value": "6 km/hr"
        },
        {
            "name": "Distance to central storage facility",
            "value": "0.5 km"
        },
        {
            "name": "Bulking factor",
            "value": 1.1
        },
        {
            "name": "Haulage capacity for A4",
            "value": "10 m3"
        },
        {
            "name": "Fully laden for A4",
            "value": "1.1 kgCO2/km"
        },
        {
            "name": "Unladen (return trip)",
            "value": "0.9 kgCO2/km"
        }
    ]
},
    //Geotechnics card for GT.Earthworks.Fill.Imported
    {
    "id": "GT.Earthworks.Fill.Imported",
    "name": "Earthworks Fill",
    "subtitle": "Material imported to site",
    "category": "Geotechnics",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "-",
    "region": "UK",
    "carbonDatabase": "",
    "A1-3": 13.2,
    "A4": 9.3,
    "A5": 3.7,
    "totalCarbon": 26.3,
    "units": "kgCO2e/m3",
    "description": "Earthworks fill activity assuming the use of an excavator (Cat325), a dozer (Cat D7), an ADT (Bell 30 ) and a compacter (Cat CS45B) on site",
    "references": [
        "CO2ST (Arup, 2017)",
        "Caterpillar Performance Handbook, January 2016"
    ],
    "tags": [
        "Earthworks",
        "Fill",
        "Soil",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.Earthworks.Fill.Imported.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 13.2
        },
        {
            "name": "Transport (A4)",
            "value": 9.3
        },
        {
            "name": "Site activities (A5)",
            "value": 3.7
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, general UK",
            "value": 22.6
        },
        {
            "name": "Diesel",
            "value": 3.7
        }
    ],
    "components": [
        {
            "name": "Excavator",
            "value": 0.4
        },
        {
            "name": "Dozer",
            "value": 0.6
        },
        {
            "name": "ADT",
            "value": 0.9
        },
        {
            "name": "Compactor",
            "value": 0.5
        },
        {
            "name": "General UK Aggregate",
            "value": 12.0
        },
        {
            "name": "transport of aggregate to site",
            "value": 12.0
        }
    ],
    "designAssumptions": [
        {
            "name": "A5 site activities",
            "value": "Included"
        },
        {
            "name": "General aggregate density",
            "value": "1600 kg/m3"
        },
        {
            "name": "General aggregate embodied carbon",
            "value": "0.0075 kgCO2/kg"
        },
        {
            "name": "Compaction factor",
            "value": 1.15
        },
        {
            "name": "Distance to central storage facility",
            "value": "0.5 km"
        },
        {
            "name": "ADT haulage volume",
            "value": "15 m3"
        },
        {
            "name": "ADT Speed",
            "value": "6 km/hr"
        },
        {
            "name": "Emissions per litre of diesel",
            "value": "2.762 kgCO2/l"
        },
        {
            "name": "Excavator fuel use",
            "value": "20 l/hr"
        },
        {
            "name": "Dozer fuel use",
            "value": "34.2 l/hr"
        },
        {
            "name": "Compactor fuel use",
            "value": "12.5 l/hr"
        },
        {
            "name": "ADT fuel use",
            "value": "29 l/hr"
        },
        {
            "name": "Haulage capacity for A4",
            "value": "10 m3"
        },
        {
            "name": "Fully laden for A4",
            "value": "1.1 kgCO2/km"
        },
        {
            "name": "Unladen return trip)",
            "value": "0.9 kgCO2/km"
        }
    ]
},
    //Geotechnics card for GT.RetainingWall.EmbeddedWall.SecantBoredPileWallCantilever5m
    {
    "id": "GT.RetainingWall.EmbeddedWall.SecantBoredPileWallCantilever5m",
    "name": "Retaining wall",
    "subtitle": "Secant bored pile wall - cantilever",
    "category": "Geotechnics",
    "subCategory": "Retaining walls",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 2976.0,
    "A4": 161.7,
    "A5": 254.4,
    "totalCarbon": 3392.1,
    "units": "kgCO2e/m plan length of wall",
    "description": "Cantilever secant pile embedded retaining wall, 5m retained height, 900mm diameter piles at 1.5m secondary pile centres",
    "references": [
        "ICE Database v3.0b 2019",
        "CIRIA C760"
    ],
    "tags": [
        "Retaining wall",
        "Secant pile",
        "Cantilever",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.RetainingWall.EmbeddedWall.SecantBoredPileWallCantilever5m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 2976.0
        },
        {
            "name": "Transport (A4)",
            "value": 161.7
        },
        {
            "name": "Site activities (A5)",
            "value": 254.4
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 2374.3
        },
        {
            "name": "Steel reinforcement",
            "value": 929.7
        },
        {
            "name": "Soil waste",
            "value": 88.1
        }
    ],
    "components": [
        {
            "name": "Primary piles",
            "value": 1924.9
        },
        {
            "name": "Secondary piles",
            "value": 725.6
        },
        {
            "name": "Capping beam",
            "value": 653.5
        },
        {
            "name": "Pile arisings",
            "value": 88.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained height",
            "value": "5m"
        },
        {
            "name": "Pile diameter",
            "value": "0.9m"
        },
        {
            "name": "Pile spacing (secondary-secondary)",
            "value": "1.5m"
        },
        {
            "name": "Primary pile embeddement below formation",
            "value": "2m"
        },
        {
            "name": "Secondary pile & capping beam reinforcement",
            "value": 0.02
        },
        {
            "name": "Capping beam dimensions",
            "value": "1.2x1.5m deep"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped7.5m
    {
    "id": "GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped7.5m",
    "name": "Retaining wall",
    "subtitle": "Secant bored pile wall - propped",
    "category": "Geotechnics",
    "subCategory": "Retaining walls",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 4414.7,
    "A4": 211.3,
    "A5": 326.5,
    "totalCarbon": 4952.6,
    "units": "kgCO2e/m plan length of wall",
    "description": "Temporarily propped secant pile embedded retaining wall, 7.5m retained height, 900mm diameter piles at 1.5m secondary pile centres",
    "references": [
        "ICE Database v3.0b 2019",
        "CIRIA C760"
    ],
    "tags": [
        "Retaining wall",
        "Secant pile",
        "Propped",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped7.5m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 4414.7
        },
        {
            "name": "Transport (A4)",
            "value": 211.3
        },
        {
            "name": "Site activities (A5)",
            "value": 326.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 3037.5
        },
        {
            "name": "Steel reinforcement",
            "value": 1068.6
        },
        {
            "name": "Soil waste",
            "value": 110.7
        },
        {
            "name": "Structural steel section",
            "value": 735.9
        }
    ],
    "components": [
        {
            "name": "Primary piles",
            "value": 2309.8
        },
        {
            "name": "Secondary piles",
            "value": 984.9
        },
        {
            "name": "Capping beam",
            "value": 653.5
        },
        {
            "name": "Steel props",
            "value": 735.9
        },
        {
            "name": "Thrust block",
            "value": 157.9
        },
        {
            "name": "Pile arisings",
            "value": 110.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained height",
            "value": "7.5m"
        },
        {
            "name": "Pile diameter",
            "value": "0.9m"
        },
        {
            "name": "Pile spacing (secondary-secondary)",
            "value": "1.5m"
        },
        {
            "name": "Primary pile embeddement below formation",
            "value": "2m"
        },
        {
            "name": "Secondary pile & capping beam reinforcement",
            "value": 0.02
        },
        {
            "name": "Capping beam dimensions",
            "value": "1.2x1.5m deep"
        },
        {
            "name": "Steel prop",
            "value": "508x10 CHS at 6m spacing"
        },
        {
            "name": "Prop steel type",
            "value": "UK hollow sections: TATA EPD (IStructE, 2020)"
        },
        {
            "name": "Thrust block dimensions",
            "value": "2x2x1m"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        },
        {
            "name": "Prop steel type",
            "value": "UK hollow sections: TATA EPD (IStructE, 2020)"
        }
    ]
},
    //Geotechnics card for GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped10m
    {
    "id": "GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped10m",
    "name": "Retaining wall",
    "subtitle": "Secant bored pile wall - propped",
    "category": "Geotechnics",
    "subCategory": "Retaining walls",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 6891.7,
    "A4": 337.6,
    "A5": 529.0,
    "totalCarbon": 7758.2,
    "units": "kgCO2e/m plan length of wall",
    "description": "Temporarily propped secant pile embedded retaining wall, 10m retained height, 1200mm diameter piles at 2.1m secondary pile centres",
    "references": [
        "ICE Database v3.0b 2019",
        "CIRIA C760"
    ],
    "tags": [
        "Retaining wall",
        "Secant pile",
        "Propped",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.RetainingWall.EmbeddedWall.SecantBoredPileWallPropped10m.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 6891.7
        },
        {
            "name": "Transport (A4)",
            "value": 337.6
        },
        {
            "name": "Site activities (A5)",
            "value": 529.0
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 4864.9
        },
        {
            "name": "Steel reinforcement",
            "value": 1763.8
        },
        {
            "name": "Structural steel section",
            "value": 946.1
        },
        {
            "name": "Soil waste",
            "value": 183.5
        }
    ],
    "components": [
        {
            "name": "Primary piles",
            "value": 3910.7
        },
        {
            "name": "Secondary piles",
            "value": 1579.6
        },
        {
            "name": "Capping beam",
            "value": 980.2
        },
        {
            "name": "Steel props",
            "value": 946.1
        },
        {
            "name": "Thrust block",
            "value": 157.9
        },
        {
            "name": "Pile arisings",
            "value": 183.5
        }
    ],
    "designAssumptions": [
        {
            "name": "Retained height",
            "value": "10m"
        },
        {
            "name": "Pile diameter",
            "value": "1.2m"
        },
        {
            "name": "Pile spacing (secondary-secondary)",
            "value": "2.1m"
        },
        {
            "name": "Primary pile embeddement below formation",
            "value": "2m"
        },
        {
            "name": "Secondary pile & capping beam reinforcement",
            "value": 0.02
        },
        {
            "name": "Capping beam dimensions",
            "value": "1.5x1.8m deep"
        },
        {
            "name": "Steel prop",
            "value": "508x10 CHS at 6m spacing"
        },
        {
            "name": "Thrust block dimensions",
            "value": "2x2x1m"
        },
        {
            "name": "Concrete type",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle250mm
    {
    "id": "GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle250mm",
    "name": "Driven steel tubular pile",
    "subtitle": "Single pile 250mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 2062.8,
    "A4": 46.7,
    "A5": 21.5,
    "totalCarbon": 2131.1,
    "units": "kgCO2e/pile",
    "description": "Single driven steel tubular pile. Diameter of 250mm, length of 15m, pilecap constructed on top of pile with 1% steel reinforcement, 59% recycled steel tubing content.",
    "references": [
        "ICE Database v3.0b 2019",
        "Taranto, Tubular steel driven piles (for sizing)"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle250mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 2062.8
        },
        {
            "name": "Transport (A4)",
            "value": 46.7
        },
        {
            "name": "Site activities (A5)",
            "value": 21.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 48.1
        },
        {
            "name": "Steel reinforcement",
            "value": 10.8
        },
        {
            "name": "Structural steel section",
            "value": 2072.2
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 2072.2
        },
        {
            "name": "Pilecap",
            "value": 58.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "250mm"
        },
        {
            "name": "Pile length",
            "value": "15m"
        },
        {
            "name": "Pipe thickness",
            "value": "12mm"
        },
        {
            "name": "Pilecap dimensions",
            "value": "0.55 x 0.55 x 0.55m"
        },
        {
            "name": "Steel reinforcement percentage in pile cap",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Recycled proportion of steel pipe",
            "value": "59% (UK Average)"
        },
        {
            "name": "Pile infill",
            "value": "Pile is left hollow"
        },
        {
            "name": "Concrete type (pile cap)",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type (pile cap)",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        },
        {
            "name": "Steel pile type",
            "value": "Steel, welded pipe, 59% recycled"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle350mm
    {
    "id": "GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle350mm",
    "name": "Driven steel tubular pile",
    "subtitle": "Single pile 350mm diameter",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Steel",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 3895.1,
    "A4": 85.3,
    "A5": 40.5,
    "totalCarbon": 4021.0,
    "units": "kgCO2e/pile",
    "description": "Single driven steel tubular pile. Diameter of 350mm, length of 20m, pilecap constructed on top of pile with 1% steel reinforcement, 59% recycled steel tubing content.",
    "references": [
        "ICE Database v3.0b 2019",
        "Taranto, Tubular steel driven piles (for sizing)"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Steel",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.DrivenPile.SteelDrivenPileSingle350mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 3895.1
        },
        {
            "name": "Transport (A4)",
            "value": 85.3
        },
        {
            "name": "Site activities (A5)",
            "value": 40.5
        }
    ],
    "materials": [
        {
            "name": "Concrete",
            "value": 79.2
        },
        {
            "name": "Steel reinforcement",
            "value": 18.0
        },
        {
            "name": "Structural steel section",
            "value": 3923.7
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 3923.7
        },
        {
            "name": "Pilecap",
            "value": 97.2
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile diameter",
            "value": "350mm"
        },
        {
            "name": "Pile length",
            "value": "20m"
        },
        {
            "name": "Pipe thickness",
            "value": "12mm"
        },
        {
            "name": "Pilecap dimensions",
            "value": "0.65 x 0.65 x 0.65m"
        },
        {
            "name": "Steel reinforcement percentage in pile cap",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Recycled proportion of steel pipe",
            "value": "59% (UK Average)"
        },
        {
            "name": "Pile infill",
            "value": "Pile is left hollow"
        },
        {
            "name": "Concrete type (pile cap)",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type (pile cap)",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        },
        {
            "name": "Steel pile type",
            "value": "Steel, welded pipe, 59% recycled"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle350mm
    {
    "id": "GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle350mm",
    "name": "Driven precast reinforced concrete pile",
    "subtitle": "Single pile 350x350mm wide",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 929.6,
    "A4": 162.3,
    "A5": 11.7,
    "totalCarbon": 1103.6,
    "units": "kgCO2e/pile",
    "description": "Single driven precast reinforced concrete pile. 350 by 350mm wide, length of 15m, pilecap constructed on top of pile, 1% steel reinforcement.",
    "references": [
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle350mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 929.6
        },
        {
            "name": "Transport (A4)",
            "value": 162.3
        },
        {
            "name": "Site activities (A5)",
            "value": 11.7
        }
    ],
    "materials": [
        {
            "name": "Insitu concrete",
            "value": 79.2
        },
        {
            "name": "Precast reinforced concrete",
            "value": 1006.4
        },
        {
            "name": "Steel reinforcement",
            "value": 18.0
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 1006.4
        },
        {
            "name": "Pilecap",
            "value": 97.2
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile width",
            "value": "350mm"
        },
        {
            "name": "Pile breadth",
            "value": "350mm"
        },
        {
            "name": "Pile length",
            "value": "15m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "0.65 x 0.65 x 0.65m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Reinforced concrete material",
            "value": "Precast concrete inluding 100kg rebar per m3 of concrete."
        },
        {
            "name": "Concrete type (pile cap)",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type (pile cap)",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Geotechnics card for GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle450mm
    {
    "id": "GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle450mm",
    "name": "Driven precast reinforced concrete pile",
    "subtitle": "Single pile 450x450mm wide",
    "category": "Geotechnics",
    "subCategory": "Deep foundations",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 1999.5,
    "A4": 343.4,
    "A5": 24.6,
    "totalCarbon": 2367.5,
    "units": "kgCO2e/pile",
    "description": "Single driven precast reinforced concrete pile. 450 by 450mm wide, length of 20m, pilecap constructed on top of pile, 1% steel reinforcement.",
    "references": [
        "ICE Database v3.0b 2019"
    ],
    "tags": [
        "Foundation",
        "Deep foundation",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Louis Andrews",
        "Paul Bailie",
        "Chris Freakes"
    ],
    "Unnamed: 24": "",
    "src": require("@/store/typ-images/GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle450mm.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 1999.5
        },
        {
            "name": "Transport (A4)",
            "value": 343.4
        },
        {
            "name": "Site activities (A5)",
            "value": 24.6
        }
    ],
    "materials": [
        {
            "name": "Insitu concrete",
            "value": 121.7
        },
        {
            "name": "Precast reinforced concrete",
            "value": 2218.3
        },
        {
            "name": "Steel reinforcement",
            "value": 27.7
        }
    ],
    "components": [
        {
            "name": "Pile",
            "value": 2218.3
        },
        {
            "name": "Pilecap",
            "value": 149.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Pile width",
            "value": "450mm"
        },
        {
            "name": "Pile breadth",
            "value": "450mm"
        },
        {
            "name": "Pile length",
            "value": "20m"
        },
        {
            "name": "Pilecap dimensions",
            "value": "0.75 x 0.75 x 0.75m"
        },
        {
            "name": "Steel reinforcement percentage",
            "value": 0.01
        },
        {
            "name": "Temporary working platform",
            "value": "Not included"
        },
        {
            "name": "Reinforced concrete material",
            "value": "Precast concrete inluding 100kg rebar per m3 of concrete."
        },
        {
            "name": "Concrete type (pile cap)",
            "value": "Concrete RC32/40 with 50% GGBS"
        },
        {
            "name": "Reinforcement type (pile cap)",
            "value": "UK reinforcement: UK CARES Sector Average EPD"
        }
    ]
},
    //Civils card for CV.Earthworks.Site_Clearance.Urban_site_clearance
    {
    "id": "CV.Earthworks.Site_Clearance.Urban_site_clearance",
    "name": "Site Clearance, Urban site clearance",
    "subtitle": "Removal of the  top layer of soil where most of the plants grow, surface soil, levelling and preparing the soil for construction works.  Usually assumed to be the  first 300mm layer.",
    "category": "Civils",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Soil & organic matter",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 2.1,
    "A4": 1.8,
    "A5": 0.6,
    "totalCarbon": 4.6,
    "units": "kgCO2e/m2",
    "description": " ",
    "references": [
        "ICE Database 2019",
        "https://transportation.ae/equipment-fuel-consumption/#Low_Consumption",
        "https://www.methvin.org/construction-production-rates/excavation/trench-excavation"
    ],
    "tags": [
        "Civils",
        "Earthworks",
        "Soil & organic matter",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Earthworks.Site_Clearance.Urban_site_clearance.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 2.1
        },
        {
            "name": "Transport (A4)",
            "value": 1.8
        },
        {
            "name": "Site activities (A5)",
            "value": 0.6
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from virgin land won resou",
            "value": 4.3
        },
        {
            "name": "Earth movement on site",
            "value": 0.3
        }
    ],
    "components": [
        {
            "name": "Soil Excavated - Exported",
            "value": 4.3
        },
        {
            "name": "Earth movement on site",
            "value": 0.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Depth of topsoil strip",
            "value": "300mm"
        },
        {
            "name": "Strip width",
            "value": "1m"
        },
        {
            "name": "Strip length",
            "value": "1m"
        },
        {
            "name": "Excavation time for clay soils ",
            "value": "33m3/h"
        },
        {
            "name": "Fuel engine type",
            "value": "Diesel"
        },
        {
            "name": "Fuel consumption",
            "value": "12l/h"
        },
        {
            "name": "Waste disposal",
            "value": "Locally"
        }
    ]
},
    //Civils card for CV.Earthworks.Site_Clearance.Rural_site_clearance
    {
    "id": "CV.Earthworks.Site_Clearance.Rural_site_clearance",
    "name": "Site Clearance, Rural site clearance",
    "subtitle": "Removal of the  top layer of soil where most of the plants grow, surface soil, levelling and preparing the soil for construction works.  Usually assumed to be the  first 100mm layer.",
    "category": "Civils",
    "subCategory": "Earthworks",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Soil & organic matter",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 0.7,
    "A4": 0.9,
    "A5": 0.2,
    "totalCarbon": 1.8,
    "units": "kgCO2e/m2",
    "description": " ",
    "references": [
        "ICE Database 2019",
        "https://transportation.ae/equipment-fuel-consumption/#Low_Consumption",
        "https://www.methvin.org/construction-production-rates/excavation/trench-excavation"
    ],
    "tags": [
        "Civils",
        "Earthworks",
        "Soil & organic matter",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Earthworks.Site_Clearance.Rural_site_clearance.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 0.7
        },
        {
            "name": "Transport (A4)",
            "value": 0.9
        },
        {
            "name": "Site activities (A5)",
            "value": 0.2
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from virgin land won resou",
            "value": 1.7
        },
        {
            "name": "Earth movement on site",
            "value": 0.1
        }
    ],
    "components": [
        {
            "name": "Soil Excavated - Exported",
            "value": 1.7
        },
        {
            "name": "Earth movement on site",
            "value": 0.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Depth of topsoil strip",
            "value": "300mm"
        },
        {
            "name": "Strip width",
            "value": "1m"
        },
        {
            "name": "Strip length",
            "value": "1m"
        },
        {
            "name": "Excavation time for clay soils ",
            "value": "33m3/h"
        },
        {
            "name": "Fuel engine type",
            "value": "Diesel"
        },
        {
            "name": "Fuel consumption",
            "value": "12l/h"
        },
        {
            "name": "Waste disposal",
            "value": "Locally"
        },
        {
            "name": "",
            "value": ""
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_poor_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_poor_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Main Local Road, poor existing ground",
    "subtitle": "3.2m wide lane, traffic approx 50 msa (Range approx. 25-80 msa), CBR<5 (Assumed poor existing ground), foundation class 2, capping and subbase. (DMRB CD 225 and CD 226)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 244.7,
    "A4": 22.2,
    "A5": 17.7,
    "totalCarbon": 284.6,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_poor_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 244.7
        },
        {
            "name": "Transport (A4)",
            "value": 22.2
        },
        {
            "name": "Site activities (A5)",
            "value": 17.7
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 39.7
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 93.9
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 102.0
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 27.1
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 21.9
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 39.7
        },
        {
            "name": "Type 1 Subbase",
            "value": 93.9
        },
        {
            "name": "Road base course",
            "value": 102.0
        },
        {
            "name": "Binder course",
            "value": 27.1
        },
        {
            "name": "Surface course",
            "value": 21.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA ",
            "value": 50
        },
        {
            "name": "CBR",
            "value": "<5"
        },
        {
            "name": "Ground conditions ",
            "value": "Poor"
        },
        {
            "name": "Foundation Class",
            "value": "Class 2, capping and sub-base"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "3.2m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "400mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "250mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "240mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_good_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_good_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Main Local Road, good existing ground",
    "subtitle": "3.2m wide lane, traffic approx 50 msa (Range approx. 25-80 msa), CBR>5 (Assumed good existing ground), foundation class 2, capping and subbase(DMRB CD 225 and CD 226)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 217.3,
    "A4": 18.3,
    "A5": 15.0,
    "totalCarbon": 250.7,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Main_Local_Road,_good_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 217.3
        },
        {
            "name": "Transport (A4)",
            "value": 18.3
        },
        {
            "name": "Site activities (A5)",
            "value": 15.0
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 24.8
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 75.2
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 101.7
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 27.1
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 21.9
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 24.8
        },
        {
            "name": "Type 1 Subbase",
            "value": 75.2
        },
        {
            "name": "Road base course",
            "value": 101.7
        },
        {
            "name": "Binder course",
            "value": 27.1
        },
        {
            "name": "Surface course",
            "value": 21.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 50
        },
        {
            "name": "CBR",
            "value": ">5"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Foundation class",
            "value": "Class 2, capping and sub-base"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "3.2m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "250mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "200mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "240mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_poor_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_poor_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Minor Local Road, poor existing ground",
    "subtitle": "3.2m wide lane, traffic approx <20 msa, CBR<5 (Assumed poor existing ground)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 220.7,
    "A4": 14.1,
    "A5": 17.5,
    "totalCarbon": 252.3,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_poor_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 220.7
        },
        {
            "name": "Transport (A4)",
            "value": 14.1
        },
        {
            "name": "Site activities (A5)",
            "value": 17.5
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 150.3
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 53.0
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 27.1
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 21.9
        }
    ],
    "components": [
        {
            "name": "Type 1 Subbase",
            "value": 150.3
        },
        {
            "name": "Road base course",
            "value": 53.0
        },
        {
            "name": "Binder course",
            "value": 27.1
        },
        {
            "name": "Surface course",
            "value": 21.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 20
        },
        {
            "name": "CBR",
            "value": "<5"
        },
        {
            "name": "Ground conditions ",
            "value": "Poor"
        },
        {
            "name": "Foundation class",
            "value": "Class 2"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "3.2m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Sub-base Depth",
            "value": "400mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "125mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_good_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_good_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Minor Local Road, good existing ground",
    "subtitle": "3.2m wide lane, traffic approx <20 msa, CBR>5 (Assumed good existing ground)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 139.6,
    "A4": 9.3,
    "A5": 9.4,
    "totalCarbon": 158.3,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Minor_Local_Road,_good_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 139.6
        },
        {
            "name": "Transport (A4)",
            "value": 9.3
        },
        {
            "name": "Site activities (A5)",
            "value": 9.4
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 56.4
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 53.0
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 27.1
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 21.9
        }
    ],
    "components": [
        {
            "name": "Type 1 Subbase",
            "value": 56.4
        },
        {
            "name": "Road base course",
            "value": 53.0
        },
        {
            "name": "Binder course",
            "value": 27.1
        },
        {
            "name": "Surface course",
            "value": 21.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 20
        },
        {
            "name": "CBR",
            "value": ">5"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Foundation",
            "value": "Class 2"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "3.2m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Sub-base Depth",
            "value": "150mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "125mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_poor_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_poor_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Highway or Trunk Road, poor existing ground",
    "subtitle": "4m wide lane, traffic >80 msa, CBR<5 (Assumed poor existing ground), foundation class 3, capping and subbase, (DMRB CD 225 and CD 226)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 279.7,
    "A4": 25.3,
    "A5": 22.3,
    "totalCarbon": 327.3,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_poor_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 279.7
        },
        {
            "name": "Transport (A4)",
            "value": 25.3
        },
        {
            "name": "Site activities (A5)",
            "value": 22.3
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 49.6
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 150.3
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 66.2
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 34.2
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 26.9
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 49.6
        },
        {
            "name": "Type 1 Subbase",
            "value": 150.3
        },
        {
            "name": "Road base course",
            "value": 66.2
        },
        {
            "name": "Binder course",
            "value": 34.2
        },
        {
            "name": "Surface course",
            "value": 26.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 80
        },
        {
            "name": "CBR",
            "value": "<5"
        },
        {
            "name": "Ground conditions ",
            "value": "Poor"
        },
        {
            "name": "Foundation Class",
            "value": "Class 3, capping and sub-base"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "4m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "400mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "320mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "125mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_good_existing_ground
    {
    "id": "CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_good_existing_ground",
    "name": "Trafficked asphalt carriageway, Adopted Carriageway, Highway or Trunk Road, good existing ground",
    "subtitle": "4m wide lane, traffic >80 msa, CBR>5 (Assumed good existing ground), foundation class 3, capping and subbase, (DMRB CD 225 and CD 226)",
    "category": "Civils",
    "subCategory": "Pavement",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 247.9,
    "A4": 20.6,
    "A5": 19.1,
    "totalCarbon": 287.5,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included. Asphalt surface laying and rolling values incuded",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Trafficked_asphalt_carriageway.Adopted_Carriageway,_Highway_or_Trunk_Road,_good_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 247.9
        },
        {
            "name": "Transport (A4)",
            "value": 20.6
        },
        {
            "name": "Site activities (A5)",
            "value": 19.1
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 31.0
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 129.2
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 66.2
        },
        {
            "name": "Asphalt, 5% binder content",
            "value": 34.2
        },
        {
            "name": "Road surface,  asphalt, 5% binder content",
            "value": 26.9
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 31.0
        },
        {
            "name": "Type 1 Subbase",
            "value": 129.2
        },
        {
            "name": "Road base course",
            "value": 66.2
        },
        {
            "name": "Binder course",
            "value": 34.2
        },
        {
            "name": "Surface course",
            "value": 26.9
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 80
        },
        {
            "name": "CBR",
            "value": ">5"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Foundation Class",
            "value": "Class 3, capping and sub-base"
        },
        {
            "name": "Surfacing",
            "value": "Surface course includes energy required for laying and compacting"
        },
        {
            "name": "Lanes",
            "value": "1 lane"
        },
        {
            "name": "Lane Width",
            "value": "4m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "250mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "275mm"
        },
        {
            "name": "Road Base Course Depth",
            "value": "125mm"
        },
        {
            "name": "Binder course",
            "value": "60mm"
        },
        {
            "name": "Surface Course Depth",
            "value": "40mm"
        }
    ]
},
    //Civils card for CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Poor_exisitng_ground
    {
    "id": "CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Poor_exisitng_ground",
    "name": "Concrete Carriageway, Adopted Carriageway, Main Local Road, Poor exisitng ground",
    "subtitle": "3.2m wide lane, CBR <5%, traffic assumption = 50msa, Class 2 foundation, no overrun. Steel reinforcemnt at approx 300mm centres, 15mm dia bars",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 394.7,
    "A4": 19.6,
    "A5": 33.1,
    "totalCarbon": 447.4,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Poor_exisitng_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 394.7
        },
        {
            "name": "Transport (A4)",
            "value": 19.6
        },
        {
            "name": "Site activities (A5)",
            "value": 33.1
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 39.7
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 93.9
        },
        {
            "name": "Concrete PAV1 with 30% PFA cement",
            "value": 223.8
        },
        {
            "name": "Steel, Rebar",
            "value": 90.0
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 39.7
        },
        {
            "name": "Type 1 Subbase",
            "value": 93.9
        },
        {
            "name": "Concrete pavement ",
            "value": 223.8
        },
        {
            "name": "Steel reinforcement",
            "value": 90.0
        }
    ],
    "designAssumptions": []
},
    //Civils card for CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Good_existing_ground
    {
    "id": "CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Good_existing_ground",
    "name": "Concrete Carriageway, Adopted Carriageway, Main Local Road, Good existing ground",
    "subtitle": "3.2m wide lane, CBR>5%, traffic assumption = 50msa, Class 2 foundation, no overrun. Steel reinforcemnt at approx 300mm centres, 15mm dia bars",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 336.1,
    "A4": 12.3,
    "A5": 27.2,
    "totalCarbon": 375.6,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Concrete_Carriageway.Adopted_Carriageway,_Main_Local_Road,_Good_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 336.1
        },
        {
            "name": "Transport (A4)",
            "value": 12.3
        },
        {
            "name": "Site activities (A5)",
            "value": 27.2
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 14.9
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 47.0
        },
        {
            "name": "Concrete PAV1 with 30% PFA cement",
            "value": 223.8
        },
        {
            "name": "Steel, Rebar",
            "value": 90.0
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 14.9
        },
        {
            "name": "Type 1 Subbase",
            "value": 47.0
        },
        {
            "name": "Concrete pavement ",
            "value": 223.8
        },
        {
            "name": "Steel reinforcement",
            "value": 90.0
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 50
        },
        {
            "name": "CBR",
            "value": ">5"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Foundation Class",
            "value": "Class 2"
        },
        {
            "name": "Lane Width",
            "value": "3.2m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "150mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "125mm"
        },
        {
            "name": "Concrete pavement Depth",
            "value": "230mm"
        },
        {
            "name": "Steel reinforcement size",
            "value": "15mm"
        },
        {
            "name": "Steel reinforcement distance",
            "value": "300mm"
        },
        {
            "name": "Steel reinforcement arrangement",
            "value": "Centre, transverse and longitudinal"
        }
    ]
},
    //Civils card for CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_poor_existing_ground,_approx_400_msa
    {
    "id": "CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_poor_existing_ground,_approx_400_msa",
    "name": "Concrete Carriageway, Adopted Motorway Major Trunk Road, poor existing ground, approx 400 msa",
    "subtitle": "4m wide lane, CBR<5%, traffic assumption = 400msa, Class 3 foundation, no overrun. Steel reinforcemnt at approx 300mm centres, 15mm dia bars, Concrete f(f) = 5.0 Mpa",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 527.9,
    "A4": 26.5,
    "A5": 44.1,
    "totalCarbon": 598.5,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_poor_existing_ground,_approx_400_msa.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 527.9
        },
        {
            "name": "Transport (A4)",
            "value": 26.5
        },
        {
            "name": "Site activities (A5)",
            "value": 44.1
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 49.6
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 150.3
        },
        {
            "name": "Concrete PAV1 with 30% PFA cement",
            "value": 290.6
        },
        {
            "name": "Steel, Rebar",
            "value": 108.0
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 49.6
        },
        {
            "name": "Type 1 Subbase",
            "value": 150.3
        },
        {
            "name": "Concrete pavement ",
            "value": 290.6
        },
        {
            "name": "Steel reinforcement",
            "value": 108.0
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 400
        },
        {
            "name": "CBR",
            "value": "<5"
        },
        {
            "name": "Ground conditions ",
            "value": "Poor"
        },
        {
            "name": "Foundation Class",
            "value": "Class 3"
        },
        {
            "name": "Lane Width",
            "value": "4m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "400mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "250mm"
        },
        {
            "name": "Concrete pavement Depth",
            "value": "250mm"
        },
        {
            "name": "Steel reinforcement size",
            "value": "15mm"
        },
        {
            "name": "Steel reinforcement distance",
            "value": "300mm"
        },
        {
            "name": "Steel reinforcement arrangement",
            "value": "Centre, transverse and longitudinal"
        }
    ]
},
    //Civils card for CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_good_existing_ground,_approx_400_msa
    {
    "id": "CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_good_existing_ground,_approx_400_msa",
    "name": "Concrete Carriageway, Adopted Motorway Major Trunk Road, good existing ground, approx 400 msa",
    "subtitle": "4m wide lane, CBR>5%, traffic assumption = 400msa, Class 3 foundation, no overrun. Steel reinforcemnt at approx 300mm centres, 15mm dia bars, Concrete f(f) = 5.0 Mpa",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 440.4,
    "A4": 16.6,
    "A5": 35.3,
    "totalCarbon": 492.3,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Concrete_Carriageway.Adopted_Motorway_Major_Trunk_Road,_good_existing_ground,_approx_400_msa.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 440.4
        },
        {
            "name": "Transport (A4)",
            "value": 16.6
        },
        {
            "name": "Site activities (A5)",
            "value": 35.3
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, mixture of recycled and se",
            "value": 18.6
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 75.2
        },
        {
            "name": "Concrete PAV1 with 30% PFA cement",
            "value": 290.6
        },
        {
            "name": "Steel, Rebar",
            "value": 108.0
        }
    ],
    "components": [
        {
            "name": "Class 6 F Capping layer",
            "value": 18.6
        },
        {
            "name": "Type 1 Subbase",
            "value": 75.2
        },
        {
            "name": "Concrete pavement ",
            "value": 290.6
        },
        {
            "name": "Steel reinforcement",
            "value": 108.0
        }
    ],
    "designAssumptions": [
        {
            "name": "MSA",
            "value": 400
        },
        {
            "name": "CBR",
            "value": ">5"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Foundation Class",
            "value": "Class 3"
        },
        {
            "name": "Lane Width",
            "value": "4m"
        },
        {
            "name": "Road Length",
            "value": "1m"
        },
        {
            "name": "Capping Layer Depth",
            "value": "150mm"
        },
        {
            "name": "Sub-base Depth",
            "value": "125mm"
        },
        {
            "name": "Concrete pavement Depth",
            "value": "250mm"
        },
        {
            "name": "Steel reinforcement size",
            "value": "15mm"
        },
        {
            "name": "Steel reinforcement distance",
            "value": "300mm"
        },
        {
            "name": "Steel reinforcement arrangement",
            "value": "Centre, transverse and longitudinal"
        }
    ]
},
    //Civils card for CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F1_Adopted_Footway
    {
    "id": "CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F1_Adopted_Footway",
    "name": "Non trafficked pavement or footpath, Type F1 Adopted Footway",
    "subtitle": "2.5m wide pavement, concrete pavers installed with lime-mortar bedding and kerb installed on road side .",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular Material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 174.2,
    "A4": 8.2,
    "A5": 10.0,
    "totalCarbon": 192.3,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular Material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F1_Adopted_Footway.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 174.2
        },
        {
            "name": "Transport (A4)",
            "value": 8.2
        },
        {
            "name": "Site activities (A5)",
            "value": 10.0
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 51.7
        },
        {
            "name": "Asphalt, 3% (bitumen) binder content (by mass)",
            "value": 41.3
        },
        {
            "name": "Mortar (1:2:9 Cement:Lime:Sand mix) (Using CEM ",
            "value": 18.1
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 52.2
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 10.3
        },
        {
            "name": "Concrete RC20/25 with 15% PFA cement",
            "value": 18.7
        }
    ],
    "components": [
        {
            "name": "Type 1 Subbase",
            "value": 51.7
        },
        {
            "name": "Footpath base course",
            "value": 41.3
        },
        {
            "name": "Lime mortar bedding",
            "value": 18.1
        },
        {
            "name": "Surface Pavers",
            "value": 52.2
        },
        {
            "name": "Kerb",
            "value": 10.3
        },
        {
            "name": "Concrete Kerb bedding",
            "value": 18.7
        }
    ],
    "designAssumptions": [
        {
            "name": "Footpath Width",
            "value": "2.5m"
        },
        {
            "name": "Footpath Length",
            "value": "1m"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Sub-base Depth",
            "value": "175mm"
        },
        {
            "name": "Footpath Base Course Depth",
            "value": "125mm"
        },
        {
            "name": "Pavers Bedding Depth ",
            "value": "25mm"
        },
        {
            "name": "Surface Pavers Depth ",
            "value": "65mm"
        },
        {
            "name": "Kerb Depth",
            "value": "250mm"
        },
        {
            "name": "Concrete Kerb Bedding Depth",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_poor_exisitng_ground
    {
    "id": "CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_poor_exisitng_ground",
    "name": "Non trafficked pavement or footpath, Type F2 Footway, poor exisitng ground",
    "subtitle": "2.5m wide pavement, concrete pavers and kerb installed on road side on sand laying course. Existing CBR <5%",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 165.3,
    "A4": 8.0,
    "A5": 12.9,
    "totalCarbon": 186.2,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_poor_exisitng_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 165.3
        },
        {
            "name": "Transport (A4)",
            "value": 8.0
        },
        {
            "name": "Site activities (A5)",
            "value": 12.9
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 102.7
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 15.0
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 40.8
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 10.3
        },
        {
            "name": "Concrete, average UK mix",
            "value": 17.4
        }
    ],
    "components": [
        {
            "name": "Type 1 Subbase",
            "value": 102.7
        },
        {
            "name": "Sand Paver Bedding",
            "value": 15.0
        },
        {
            "name": "50mm Thick Surface Pavers",
            "value": 40.8
        },
        {
            "name": "Kerb",
            "value": 10.3
        },
        {
            "name": "Concrete Kerb bedding",
            "value": 17.4
        }
    ],
    "designAssumptions": []
},
    //Civils card for CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_good_existing_ground
    {
    "id": "CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_good_existing_ground",
    "name": "Non trafficked pavement or footpath, Type F2 Footway, good existing ground",
    "subtitle": "2.5m wide pavement, concrete pavers and kerb installed on road side on sand laying course. Exisitng CBR >5%",
    "category": "Civils",
    "subCategory": "Highways",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 114.7,
    "A4": 5.0,
    "A5": 7.8,
    "totalCarbon": 127.5,
    "units": "kgCO2e/m",
    "description": "Earthworks excavation values not included",
    "references": [
        "ICE Database 2019",
        "DMRB CD 225 and CD 226"
    ],
    "tags": [
        "Civils",
        "Pavement",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_good_existing_ground.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 114.7
        },
        {
            "name": "Transport (A4)",
            "value": 5.0
        },
        {
            "name": "Site activities (A5)",
            "value": 7.8
        }
    ],
    "materials": [
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 44.0
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 15.0
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 40.8
        },
        {
            "name": "precast concrete paving (Blocks, Slabs, Channel",
            "value": 10.3
        },
        {
            "name": "Concrete, average UK mix",
            "value": 17.4
        }
    ],
    "components": [
        {
            "name": "Type 1 Subbase",
            "value": 44.0
        },
        {
            "name": "Sand paver bedding",
            "value": 15.0
        },
        {
            "name": "50mm thick Surface Pavers",
            "value": 40.8
        },
        {
            "name": "Kerb",
            "value": 10.3
        },
        {
            "name": "Concrete Kerb bedding",
            "value": 17.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Footpath Width",
            "value": "2.5m"
        },
        {
            "name": "Footpath Length",
            "value": "1m"
        },
        {
            "name": "Ground conditions ",
            "value": "Good"
        },
        {
            "name": "Sub-base Depth",
            "value": "150mm"
        },
        {
            "name": "Pavers Bedding Depth ",
            "value": "25mm"
        },
        {
            "name": "Surface Pavers Thickness",
            "value": "50mm"
        },
        {
            "name": "Kerb Depth",
            "value": "250mm"
        },
        {
            "name": "Concrete Kerb Bedding Depth",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Drainage.Drainage_trench.Clay_pipe
    {
    "id": "CV.Drainage.Drainage_trench.Clay_pipe",
    "name": "Drainage trench, Clay pipe",
    "subtitle": "Drainage trench for clay pipe ( 225mm) and 1.2m pipe cover, granular single size bedding. For deeper pipes add deeper trenching asset to suit.",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Clay pipe",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 25.9,
    "A4": 5.6,
    "A5": 7.6,
    "totalCarbon": 39.1,
    "units": "kgCO2e/m",
    "description": "Trench earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "Clay pipe",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Drainage_trench.Clay_pipe.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 25.9
        },
        {
            "name": "Transport (A4)",
            "value": 5.6
        },
        {
            "name": "Site activities (A5)",
            "value": 7.6
        }
    ],
    "materials": [
        {
            "name": "Vitrified clay pipework225mm diameter",
            "value": 18.8
        },
        {
            "name": "Aggregates and sand, from recycled resources, n",
            "value": 15.2
        },
        {
            "name": "On site earthworks",
            "value": 5.0
        }
    ],
    "components": [
        {
            "name": "Vitrified clay pipework",
            "value": 18.8
        },
        {
            "name": "Imported granular bedding material single size",
            "value": 15.2
        },
        {
            "name": "On site earthworks",
            "value": 5.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Pipe Material",
            "value": "Clay"
        },
        {
            "name": "Pipe Diameter",
            "value": "225mm"
        },
        {
            "name": "Trench Width",
            "value": "700mm"
        },
        {
            "name": "Trench Depth ",
            "value": "1700mm"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Cover to Pipe",
            "value": "1.2m"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "0.4m"
        }
    ]
},
    //Civils card for CV.Drainage.Drainage_trench.PVC_pipe
    {
    "id": "CV.Drainage.Drainage_trench.PVC_pipe",
    "name": "Drainage trench, PVC pipe",
    "subtitle": "Drainage trench for PVC pipe ( 150mm) and 1.2m pipe cover, granular single size bedding. For deeper pipes add deeper trenching asset to suit.",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "PVC pipe",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 17.3,
    "A4": 4.3,
    "A5": 6.2,
    "totalCarbon": 27.8,
    "units": "kgCO2e/m",
    "description": "Trench earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "PVC pipe",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Drainage_trench.PVC_pipe.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 17.3
        },
        {
            "name": "Transport (A4)",
            "value": 4.3
        },
        {
            "name": "Site activities (A5)",
            "value": 6.2
        }
    ],
    "materials": [
        {
            "name": "Plastic pipework (PVC)150mm diameter",
            "value": 10.7
        },
        {
            "name": "Aggregates and sand, from recycled resources, n",
            "value": 12.1
        },
        {
            "name": "On site eathworks",
            "value": 5.0
        }
    ],
    "components": [
        {
            "name": "PVC",
            "value": 10.7
        },
        {
            "name": "Imported granular bedding material single size",
            "value": 12.1
        },
        {
            "name": "On site eathworks",
            "value": 5.0
        }
    ],
    "designAssumptions": [
        {
            "name": "Pipe Material",
            "value": "PVC"
        },
        {
            "name": "Pipe Diameter",
            "value": "150mm"
        },
        {
            "name": "Trench Width",
            "value": "600mm"
        },
        {
            "name": "Trench Depth ",
            "value": "1700mm"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Cover to Pipe",
            "value": "1.2m"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "0.4m"
        }
    ]
},
    //Civils card for CV.Drainage.Drainage_trench.Concrete_pipe
    {
    "id": "CV.Drainage.Drainage_trench.Concrete_pipe",
    "name": "Drainage trench, Concrete pipe",
    "subtitle": "Drainage trench for Concrete pipe ( 450mm) and 2.0m pipe cover, granular single size bedding. Trench 1.1m x 1.7m",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete pipe",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 69.2,
    "A4": 1.1,
    "A5": 10.9,
    "totalCarbon": 81.2,
    "units": "kgCO2e/m",
    "description": "Trench earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "Concrete pipe",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Drainage_trench.Concrete_pipe.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 69.2
        },
        {
            "name": "Transport (A4)",
            "value": 1.1
        },
        {
            "name": "Site activities (A5)",
            "value": 10.9
        }
    ],
    "materials": [
        {
            "name": "Precast concrete circular pipework450mm diamete",
            "value": 54.9
        },
        {
            "name": "Aggregates and sand, from recycled resources, n",
            "value": 18.0
        },
        {
            "name": "On site earthworks",
            "value": 8.3
        }
    ],
    "components": [
        {
            "name": "Concrete",
            "value": 54.9
        },
        {
            "name": "Imported granular bedding material single size",
            "value": 18.0
        },
        {
            "name": "On site earthworks",
            "value": 8.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Pipe Material",
            "value": "PVC"
        },
        {
            "name": "Pipe Diameter",
            "value": "450mm"
        },
        {
            "name": "Trench Width",
            "value": "1150mm"
        },
        {
            "name": "Trench Depth ",
            "value": "2000mm"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Cover to Pipe",
            "value": "1.2m"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "0.4m"
        }
    ]
},
    //Civils card for CV.Drainage.Manhole.Precast_concrete_manhole,_SfA_Type_1_between_3_to_6m_deep
    {
    "id": "CV.Drainage.Manhole.Precast_concrete_manhole,_SfA_Type_1_between_3_to_6m_deep",
    "name": "Manhole, Precast concrete manhole, SfA Type 1 between 3 to 6m deep",
    "subtitle": "Pre-cast concrete manhole up to 6m deep according to Sewers for Adoption (Typa 1A) 1500mm diameter. Excavation to assumed to 6m deep and 1m clearance on each side",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Precast concrete manholes",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 2642.4,
    "A4": 64.9,
    "A5": 181.3,
    "totalCarbon": 2888.7,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "Precast concrete manholes",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Manhole.Precast_concrete_manhole,_SfA_Type_1_between_3_to_6m_deep.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 2642.4
        },
        {
            "name": "Transport (A4)",
            "value": 64.9
        },
        {
            "name": "Site activities (A5)",
            "value": 181.3
        }
    ],
    "materials": [
        {
            "name": "Precast concrete manholes1500mm diameter, 3m - ",
            "value": 1829.9
        },
        {
            "name": "Concrete, average UK mix",
            "value": 938.4
        },
        {
            "name": "On site earthworks",
            "value": 120.3
        }
    ],
    "components": [
        {
            "name": "Precast concrete manholes",
            "value": 1829.9
        },
        {
            "name": "Concrete surround",
            "value": 938.4
        },
        {
            "name": "On site earthworks",
            "value": 120.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Manhole material",
            "value": "Pre-cast concrete"
        },
        {
            "name": "Internal Dimensions",
            "value": "1500mm"
        },
        {
            "name": "Depth of excavation",
            "value": "6m"
        },
        {
            "name": "Concrete surround",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Drainage.Manhole.Pre_cast_concrete_manhole,_SfA_Type_2_up_to_3m_deep
    {
    "id": "CV.Drainage.Manhole.Pre_cast_concrete_manhole,_SfA_Type_2_up_to_3m_deep",
    "name": "Manhole, Pre cast concrete manhole, SfA Type 2 up to 3m deep",
    "subtitle": "Pre-cast concrete manhole up to 3m deep according to Sewers for Adoption (Type 2) 1200mm diameter. Excavation asumed to be 3m deep. And 1m clearance on each side",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Precast concrete manholes",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 2859.0,
    "A4": 56.6,
    "A5": 124.4,
    "totalCarbon": 3040.0,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "Precast concrete manholes",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Manhole.Pre_cast_concrete_manhole,_SfA_Type_2_up_to_3m_deep.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 2859.0
        },
        {
            "name": "Transport (A4)",
            "value": 56.6
        },
        {
            "name": "Site activities (A5)",
            "value": 124.4
        }
    ],
    "materials": [
        {
            "name": "Precast concrete manholes1200mm diameter, up to",
            "value": 2362.2
        },
        {
            "name": "Concrete, average UK mix",
            "value": 604.2
        },
        {
            "name": "On site earthworks",
            "value": 73.5
        }
    ],
    "components": [
        {
            "name": "Precast concrete manholes",
            "value": 2362.2
        },
        {
            "name": "Concrete surround",
            "value": 604.2
        },
        {
            "name": "On site earthworks",
            "value": 73.5
        }
    ],
    "designAssumptions": []
},
    //Civils card for CV.Drainage.Manhole.PE_chambers,_Type_3_inspection_chamber
    {
    "id": "CV.Drainage.Manhole.PE_chambers,_Type_3_inspection_chamber",
    "name": "Manhole, PE chambers, Type 3 inspection chamber",
    "subtitle": "Typical Inspection chamber Detail (Type 3) 600x600mm internal dimesions (up to 1.2m deep)",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "PE Plastic",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 1001.2,
    "A4": 8.1,
    "A5": 46.2,
    "totalCarbon": 1055.5,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "PE Plastic",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Manhole.PE_chambers,_Type_3_inspection_chamber.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 1001.2
        },
        {
            "name": "Transport (A4)",
            "value": 8.1
        },
        {
            "name": "Site activities (A5)",
            "value": 46.2
        }
    ],
    "materials": [
        {
            "name": "Plastic inspection chambers600mm diameter, up t",
            "value": 800.1
        },
        {
            "name": "Concrete, average UK mix",
            "value": 219.2
        },
        {
            "name": "On site earthworks",
            "value": 36.1
        }
    ],
    "components": [
        {
            "name": "PE",
            "value": 800.1
        },
        {
            "name": "Concrete surround",
            "value": 219.2
        },
        {
            "name": "On site earthworks",
            "value": 36.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Manhole material",
            "value": "PVC"
        },
        {
            "name": "Internal Dimensions",
            "value": "600mm"
        },
        {
            "name": "Depth of excavation",
            "value": "1.2m"
        }
    ]
},
    //Civils card for CV.Drainage.Gullies.PE_Gully
    {
    "id": "CV.Drainage.Gullies.PE_Gully",
    "name": "Gullies, PE Gully",
    "subtitle": "Standard road gully, approx 450mm x 450mm x 600mm, with PE lead pipe of approx 4m long.",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "PE Plastic",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 158.7,
    "A4": 4.1,
    "A5": 5.9,
    "totalCarbon": 168.7,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "PE Plastic",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Gullies.PE_Gully.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 158.7
        },
        {
            "name": "Transport (A4)",
            "value": 4.1
        },
        {
            "name": "Site activities (A5)",
            "value": 5.9
        }
    ],
    "materials": [
        {
            "name": "GulliesPlastic gully pots - PE",
            "value": 48.1
        },
        {
            "name": "Concrete, average UK mix",
            "value": 120.3
        },
        {
            "name": "On site earthworks",
            "value": 0.3
        }
    ],
    "components": [
        {
            "name": "Plastic Gully",
            "value": 48.1
        },
        {
            "name": "Concrete surround",
            "value": 120.3
        },
        {
            "name": "On site earthworks",
            "value": 0.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Gully Pot material",
            "value": "PE"
        },
        {
            "name": "Gully Pot Dimensions",
            "value": "450x450x600mm"
        }
    ]
},
    //Civils card for CV.Drainage.Gullies.Concrete_Gully
    {
    "id": "CV.Drainage.Gullies.Concrete_Gully",
    "name": "Gullies, Concrete Gully",
    "subtitle": "Standard concrete road gully, approx 450mm x 450mm x 600mm, with PE lead pipe of approx 4m long.",
    "category": "Civils",
    "subCategory": "Drainage",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "Highways England Carbon Tool ",
    "A1-3": 198.4,
    "A4": 5.8,
    "A5": 10.3,
    "totalCarbon": 214.4,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019",
        "Highways England Carbon Calculator"
    ],
    "tags": [
        "Civils",
        "Drainage",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage.Gullies.Concrete_Gully.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 198.4
        },
        {
            "name": "Transport (A4)",
            "value": 5.8
        },
        {
            "name": "Site activities (A5)",
            "value": 10.3
        }
    ],
    "materials": [
        {
            "name": "GulliesPrecast concrete gully pots (heavy duty)",
            "value": 93.8
        },
        {
            "name": "On site earthworks",
            "value": 0.3
        }
    ],
    "components": [
        {
            "name": "Concrete Gully",
            "value": 93.8
        },
        {
            "name": "On site earthworks",
            "value": 0.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Gully Pot material",
            "value": "Concrete"
        },
        {
            "name": "Gully Pot Dimensions",
            "value": "450x450x600mm"
        }
    ]
},
    //Civils card for CV.Drainage_SUDS.Below_Ground_attenuation.Concrete_tank_below_ground_attenuation
    {
    "id": "CV.Drainage_SUDS.Below_Ground_attenuation.Concrete_tank_below_ground_attenuation",
    "name": "Below Ground attenuation, Concrete tank below ground attenuation",
    "subtitle": "Concrete tank below ground attenuation, assumed attenuation 100m3, assumed measurements 10m x 10m x 1m, wall/column thickness = 100mm, 5m column spacing, 15mm rebar at 250mm spacing, 1.2m cover",
    "category": "Civils",
    "subCategory": "Drainage SUDS",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Concrete",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 6606.1,
    "A4": 215.2,
    "A5": 909.1,
    "totalCarbon": 7730.4,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Drainage SUDS",
        "Concrete",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage_SUDS.Below_Ground_attenuation.Concrete_tank_below_ground_attenuation.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 6606.1
        },
        {
            "name": "Transport (A4)",
            "value": 215.2
        },
        {
            "name": "Site activities (A5)",
            "value": 909.1
        }
    ],
    "materials": [
        {
            "name": "Concrete PAV1 with 30% PFA cement",
            "value": 6974.2
        },
        {
            "name": "Steel, Rebar",
            "value": 194.3
        },
        {
            "name": "On site earthworks",
            "value": 561.9
        }
    ],
    "components": [
        {
            "name": "concrete base",
            "value": 6974.2
        },
        {
            "name": "Steel Rebar",
            "value": 194.3
        },
        {
            "name": "On site earthworks",
            "value": 561.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Tank material",
            "value": "concrete"
        },
        {
            "name": "Tank Volume",
            "value": "100m3"
        },
        {
            "name": "Tank dimensions",
            "value": "10x10x1m"
        },
        {
            "name": "Wall/column thickness",
            "value": "100mm"
        },
        {
            "name": "Column spacing",
            "value": "5m"
        },
        {
            "name": "Rebar diameter",
            "value": "15mm"
        },
        {
            "name": "Rebar spacing",
            "value": "250mm"
        },
        {
            "name": "Tank cover",
            "value": "1.2m"
        }
    ]
},
    //Civils card for CV.Drainage_SUDS.Attenuation.Dry_Swale
    {
    "id": "CV.Drainage_SUDS.Attenuation.Dry_Swale",
    "name": "Attenuation, Dry Swale",
    "subtitle": "Swale per metre, 1m deep, 1:3 side slope, 1m wide at base, 1m deep gravel trench with 225mm dia perforated pipe. Assume import top 100mm topsoil on sides. Assume flat land for excavation",
    "category": "Civils",
    "subCategory": "Drainage SUDS",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Granular material",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 162.1,
    "A4": 6.0,
    "A5": 31.4,
    "totalCarbon": 199.5,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Drainage SUDS",
        "Granular material",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Drainage_SUDS.Attenuation.Dry_Swale.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 162.1
        },
        {
            "name": "Transport (A4)",
            "value": 6.0
        },
        {
            "name": "Site activities (A5)",
            "value": 31.4
        }
    ],
    "materials": [
        {
            "name": "Damp proof course and impermeable membranePolye",
            "value": 0.0
        },
        {
            "name": "Plastic pipework (HDPE)225mm diameter",
            "value": 0.0
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 117.4
        },
        {
            "name": "Aggregates and sand, from secondary resources, ",
            "value": 60.8
        },
        {
            "name": "On site earthworks",
            "value": 21.3
        }
    ],
    "components": [
        {
            "name": "Polypropene surrounding layer",
            "value": 0.0
        },
        {
            "name": "PVC pipe",
            "value": 0.0
        },
        {
            "name": "Imported granular bedding material single size",
            "value": 117.4
        },
        {
            "name": "Topsoil for sides",
            "value": 60.8
        },
        {
            "name": "On site earthworks",
            "value": 21.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Swale depth",
            "value": "1m"
        },
        {
            "name": "Side slope",
            "value": "1:3"
        },
        {
            "name": "Gravel trench depth ",
            "value": "1m"
        },
        {
            "name": "Perforated pipe diameter",
            "value": "225mm"
        },
        {
            "name": "Topsoil depth",
            "value": "100mm"
        }
    ]
},
    //Civils card for CV.Utilities.Telecoms.4_way_comms_ducts
    {
    "id": "CV.Utilities.Telecoms.4_way_comms_ducts",
    "name": "Telecoms, 4 way comms ducts",
    "subtitle": "4 way telecom duct trench. 94mm internal diameter (110mm external diameter)  uPVC  ducts with 50mm spacing between ducts.\nTypical detail for Openreach, Virgin Media",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "uPVC ducts",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 49.5,
    "A4": 1.6,
    "A5": 8.0,
    "totalCarbon": 59.1,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "uPVC ducts",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Telecoms.4_way_comms_ducts.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 49.5
        },
        {
            "name": "Transport (A4)",
            "value": 1.6
        },
        {
            "name": "Site activities (A5)",
            "value": 8.0
        }
    ],
    "materials": [
        {
            "name": "uPVC Film",
            "value": 48.7
        },
        {
            "name": "On site earthworks",
            "value": 5.1
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 5.4
        }
    ],
    "components": [
        {
            "name": "uPVC",
            "value": 48.7
        },
        {
            "name": "On site earthworks",
            "value": 5.1
        },
        {
            "name": "Sand",
            "value": 5.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Telecom Inner Duct Diameter",
            "value": "90mm"
        },
        {
            "name": "Duct Material",
            "value": "uPVC"
        },
        {
            "name": "Trench Width",
            "value": "0.55m"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Trench Depth ",
            "value": "1.1m"
        },
        {
            "name": "Cover to Ducts",
            "value": "0.45mm"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "350mm"
        },
        {
            "name": "Water Pipe Diameter",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Utilities.Potable_water.HDPE_pipe
    {
    "id": "CV.Utilities.Potable_water.HDPE_pipe",
    "name": "Potable water, HDPE pipe",
    "subtitle": "Potable water trench for 110mm HDPE pipe, SDR 11. Assumed minimum recommeded pipe cover of 900mm",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "HDPE pipe",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 9.4,
    "A4": 0.7,
    "A5": 3.6,
    "totalCarbon": 13.7,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "HDPE pipe",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Potable_water.HDPE_pipe.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 9.4
        },
        {
            "name": "Transport (A4)",
            "value": 0.7
        },
        {
            "name": "Site activities (A5)",
            "value": 3.6
        }
    ],
    "materials": [
        {
            "name": "HDPE pipe",
            "value": 8.9
        },
        {
            "name": "On site earthworks",
            "value": 2.6
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 2.3
        }
    ],
    "components": [
        {
            "name": "HDPE pipe",
            "value": 8.9
        },
        {
            "name": "On site earthworks",
            "value": 2.6
        },
        {
            "name": "Sand",
            "value": 2.3
        }
    ],
    "designAssumptions": [
        {
            "name": "Pipe Material",
            "value": "HDPE"
        },
        {
            "name": "Trench Width",
            "value": "350mm"
        },
        {
            "name": "Trench Depth ",
            "value": "1.1m"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Cover to Ducts",
            "value": "0.9m"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "0.75m"
        },
        {
            "name": "Water Pipe Diameter",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Utilities.Potable_water.Cast_iron_pipe
    {
    "id": "CV.Utilities.Potable_water.Cast_iron_pipe",
    "name": "Potable water, Cast iron pipe",
    "subtitle": "Potable water trench for 150mm Cast iron pipe. Assumed minimum recommeded pipe cover of 900mm",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Cast iron pipe",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 448.4,
    "A4": 1.5,
    "A5": 70.1,
    "totalCarbon": 519.9,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "Cast iron pipe",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Potable_water.Cast_iron_pipe.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 448.4
        },
        {
            "name": "Transport (A4)",
            "value": 1.5
        },
        {
            "name": "Site activities (A5)",
            "value": 70.1
        }
    ],
    "materials": [
        {
            "name": "Cast Iron",
            "value": 515.1
        },
        {
            "name": "On site earthworks",
            "value": 2.7
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 2.1
        }
    ],
    "components": [
        {
            "name": "Iron",
            "value": 515.1
        },
        {
            "name": "On site earthworks",
            "value": 2.7
        },
        {
            "name": "Sand",
            "value": 2.1
        }
    ],
    "designAssumptions": [
        {
            "name": "Pipe Material",
            "value": "Cast Iron"
        },
        {
            "name": "Trench Width",
            "value": "350mm"
        },
        {
            "name": "Trench Depth ",
            "value": "1.1m"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Cover to Ducts",
            "value": "0.9m"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "0.75m"
        },
        {
            "name": "HV Duct Diameter",
            "value": "150mm"
        }
    ]
},
    //Civils card for CV.Utilities.Power.4_Way_HV_Duct
    {
    "id": "CV.Utilities.Power.4_Way_HV_Duct",
    "name": "Power, 4 Way HV Duct",
    "subtitle": "4 Way HV duct trench. 150mm internal dimension duct, 300mm spacing (centre to centre)",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Polypropylene",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 34.5,
    "A4": 1.8,
    "A5": 21.2,
    "totalCarbon": 57.4,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "Polypropylene",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Power.4_Way_HV_Duct.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 34.5
        },
        {
            "name": "Transport (A4)",
            "value": 1.8
        },
        {
            "name": "Site activities (A5)",
            "value": 21.2
        }
    ],
    "materials": [
        {
            "name": "Polypropylene, Injection Moulding",
            "value": 46.5
        },
        {
            "name": "On site earthworks",
            "value": 5.0
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 5.9
        }
    ],
    "components": [
        {
            "name": "PP",
            "value": 46.5
        },
        {
            "name": "On site earthworks",
            "value": 5.0
        },
        {
            "name": "Sand",
            "value": 5.9
        }
    ],
    "designAssumptions": [
        {
            "name": "Duct Material",
            "value": "Polypropylene"
        },
        {
            "name": "Trench Width",
            "value": "0.62m"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Trench Depth ",
            "value": "0.62m"
        },
        {
            "name": "Cover to Ducts",
            "value": "0.75mm"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "570mm"
        },
        {
            "name": "LV Duct Diameter",
            "value": "100mm"
        }
    ]
},
    //Civils card for CV.Utilities.Power.4_Way_LV_Duct
    {
    "id": "CV.Utilities.Power.4_Way_LV_Duct",
    "name": "Power, 4 Way LV Duct",
    "subtitle": "4 way LV duct trench. 125mm internal dimensins, 50mm spacing between ducts",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Polypropylene",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 28.9,
    "A4": 1.9,
    "A5": 15.0,
    "totalCarbon": 45.8,
    "units": "kgCO2e/m",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "Polypropylene",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Power.4_Way_LV_Duct.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 28.9
        },
        {
            "name": "Transport (A4)",
            "value": 1.9
        },
        {
            "name": "Site activities (A5)",
            "value": 15.0
        }
    ],
    "materials": [
        {
            "name": "Polypropylene, Injection Moulding",
            "value": 37.7
        },
        {
            "name": "On site earthworks",
            "value": 1.7
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 6.4
        }
    ],
    "components": [
        {
            "name": "PP",
            "value": 37.7
        },
        {
            "name": "On site earthworks",
            "value": 1.7
        },
        {
            "name": "Sand",
            "value": 6.4
        }
    ],
    "designAssumptions": [
        {
            "name": "Duct Material",
            "value": "Polypropylene"
        },
        {
            "name": "Trench Width",
            "value": "0.586m"
        },
        {
            "name": "Trench Length",
            "value": "1m"
        },
        {
            "name": "Trench Depth ",
            "value": "0.586m"
        },
        {
            "name": "Cover to Ducts",
            "value": "0.600mm"
        },
        {
            "name": "Trench Backfill",
            "value": "Sand"
        },
        {
            "name": "Pavement build-up depth ",
            "value": "450mm"
        },
        {
            "name": "No of Stakka Modula modules",
            "value": 6
        }
    ]
},
    //Civils card for CV.Utilities.Chambers.Stakka_Quad_Chamber
    {
    "id": "CV.Utilities.Chambers.Stakka_Quad_Chamber",
    "name": "Chambers, Stakka Quad Chamber",
    "subtitle": "Modular chamber for telecoms systems. Openreach approved. 915x445mm internal dimensions",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "High Density Polyethylene (HDPE) Resin",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 269.5,
    "A4": 5.2,
    "A5": 34.9,
    "totalCarbon": 309.7,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "High Density Polyethylene (HDPE) Resin",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Chambers.Stakka_Quad_Chamber.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 269.5
        },
        {
            "name": "Transport (A4)",
            "value": 5.2
        },
        {
            "name": "Site activities (A5)",
            "value": 34.9
        }
    ],
    "materials": [
        {
            "name": "HDPE",
            "value": 162.1
        },
        {
            "name": "On site earthworks",
            "value": 25.7
        },
        {
            "name": "Concrete GEN1 with CEM I cement",
            "value": 72.6
        },
        {
            "name": "Concrete GEN 3 with CEM I cement",
            "value": 45.6
        },
        {
            "name": "Aggregates and sand, from virgin marine resourc",
            "value": 3.6
        }
    ],
    "components": [
        {
            "name": "Stakka Quad",
            "value": 162.1
        },
        {
            "name": "On site earthworks",
            "value": 25.7
        },
        {
            "name": "C16/20 concrete surround",
            "value": 72.6
        },
        {
            "name": "C20P concrete",
            "value": 45.6
        },
        {
            "name": "Sand",
            "value": 3.6
        },
        {
            "name": "Stakka Quad",
            "value": 162.1
        },
        {
            "name": "Excavation",
            "value": 31.9
        },
        {
            "name": "Earth Movement on site",
            "value": 4.0
        },
        {
            "name": "C16/20 concrete surround",
            "value": 72.6
        },
        {
            "name": "C20P concrete",
            "value": 45.6
        },
        {
            "name": "Sand",
            "value": 3.6
        }
    ],
    "designAssumptions": [
        {
            "name": "Chamber internal dimensions",
            "value": "1200 x 600mm"
        },
        {
            "name": "Excavation depth",
            "value": "1.55m"
        },
        {
            "name": "Excavation Length",
            "value": "2m"
        },
        {
            "name": "Excavation Width ",
            "value": "1.5m"
        },
        {
            "name": "Concrete surround ",
            "value": "150mm"
        },
        {
            "name": "Concrete base depth",
            "value": "150mm"
        },
        {
            "name": "Concrete base length x width",
            "value": "1.993x1.393m"
        },
        {
            "name": "Sand bedding depth",
            "value": "150mm"
        },
        {
            "name": "Sand bedding length x width",
            "value": "1.993x1.393m"
        },
        {
            "name": "No of Stakka Quad modules",
            "value": 6
        }
    ]
},
    //Civils card for CV.Utilities.Chambers.Stakka_Modula_Chamber
    {
    "id": "CV.Utilities.Chambers.Stakka_Modula_Chamber",
    "name": "Chambers, Stakka Modula Chamber",
    "subtitle": "Modular chamber for LV/HV system 1200mmx600mm internal dimension",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "Polypropylene, Injection Moulding",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 607.6,
    "A4": 14.6,
    "A5": 194.8,
    "totalCarbon": 817.1,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "Polypropylene",
        "Injection Moulding",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Chambers.Stakka_Modula_Chamber.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 607.6
        },
        {
            "name": "Transport (A4)",
            "value": 14.6
        },
        {
            "name": "Site activities (A5)",
            "value": 194.8
        }
    ],
    "materials": [
        {
            "name": "Polypropylene",
            "value": 440.8
        },
        {
            "name": "On site earthworks",
            "value": 30.6
        },
        {
            "name": "Concrete GEN1 with CEM I cement",
            "value": 172.0
        },
        {
            "name": "Concrete GEN 3 with CEM I cement",
            "value": 160.9
        },
        {
            "name": "Aggregates and sand, from virgin marine resourc",
            "value": 12.8
        }
    ],
    "components": [
        {
            "name": "Stakka Modula",
            "value": 440.8
        },
        {
            "name": "On site earthworks",
            "value": 30.6
        },
        {
            "name": "C16/20 concrete surround",
            "value": 172.0
        },
        {
            "name": "C20P concrete",
            "value": 160.9
        },
        {
            "name": "Sand",
            "value": 12.8
        },
        {
            "name": "Stakka Modula",
            "value": 440.8
        },
        {
            "name": "Excavation",
            "value": 38.1
        },
        {
            "name": "Earth Movement on site",
            "value": 4.7
        },
        {
            "name": "C16/20 concrete surround",
            "value": 172.0
        },
        {
            "name": "C20P concrete",
            "value": 160.9
        },
        {
            "name": "Sand",
            "value": 12.8
        }
    ],
    "designAssumptions": [
        {
            "name": "Chamber internal dimensions",
            "value": "915 x 475mm"
        },
        {
            "name": "Excavation depth",
            "value": "1.3m"
        },
        {
            "name": "Excavation Length",
            "value": "1.2m"
        },
        {
            "name": "Excavation Width ",
            "value": "1.5m"
        },
        {
            "name": "Concrete surround",
            "value": "150mm"
        },
        {
            "name": "Concrete base depth",
            "value": "150mm"
        },
        {
            "name": "Concrete base length x width",
            "value": "1.286x0.816m"
        },
        {
            "name": "Sand bedding depth",
            "value": "150mm"
        },
        {
            "name": "Sand bedding length x width",
            "value": "1.286x0.816m"
        },
        {
            "name": "No of pre-cast concrete units",
            "value": 8
        }
    ]
},
    //Civils card for CV.Utilities.Chambers.Precast_concrete_chambers
    {
    "id": "CV.Utilities.Chambers.Precast_concrete_chambers",
    "name": "Chambers, Precast concrete chambers",
    "subtitle": "Precast concrete chambers suitable for Comms/ LV/HV 1200mmx750 internal dimensions",
    "category": "Civils",
    "subCategory": "Utilities",
    "sector": "Infrastructure",
    "scope": "A1-5 Carbon",
    "primarymaterial": "pre-cast concrete chamber",
    "region": "UK",
    "carbonDatabase": "ICEv3b 2019",
    "A1-3": 238.2,
    "A4": 11.4,
    "A5": 69.6,
    "totalCarbon": 319.2,
    "units": "kgCO2e/unit",
    "description": "Earthworks values included",
    "references": [
        "ICE Database 2019"
    ],
    "tags": [
        "Civils",
        "Utilities",
        "pre-cast concrete chamber",
        "UK"
    ],
    "dialog": false,
    "guidanceType": "baseline",
    "authors": [
        "Raluca Olariu",
        "Richie Turner",
        "Peter Storey"
    ],
    "Unnamed: 24": 0,
    "src": require("@/store/typ-images/CV.Utilities.Chambers.Precast_concrete_chambers.png"),
    "carbon": [
        {
            "name": "Material creation (A1-3)",
            "value": 238.2
        },
        {
            "name": "Transport (A4)",
            "value": 11.4
        },
        {
            "name": "Site activities (A5)",
            "value": 69.6
        }
    ],
    "materials": [
        {
            "name": "concrete block, medium density solid, average s",
            "value": 88.7
        },
        {
            "name": "concrete block, medium density solid, average s",
            "value": 28.3
        },
        {
            "name": "On site earthworks",
            "value": 61.1
        },
        {
            "name": "Concrete GEN 3 with CEM I cement",
            "value": 131.9
        },
        {
            "name": "Aggregates and sand, general UK, mixture of lan",
            "value": 9.2
        }
    ],
    "components": [
        {
            "name": "CPM rectangular inspection chamber",
            "value": 88.7
        },
        {
            "name": "CPM cover slab",
            "value": 28.3
        },
        {
            "name": "On site earthworks",
            "value": 61.1
        },
        {
            "name": "C20P concrete",
            "value": 131.9
        },
        {
            "name": "Sand",
            "value": 9.2
        },
        {
            "name": "Sand",
            "value": 9.2
        },
        {
            "name": "CPM rectangular inspection chamber",
            "value": 88.7
        },
        {
            "name": "CPM cover slab",
            "value": 28.3
        },
        {
            "name": "Excavation",
            "value": 97.4
        },
        {
            "name": "Earth Movement on site",
            "value": 9.1
        },
        {
            "name": "C20P concrete",
            "value": 131.9
        },
        {
            "name": "Sand",
            "value": 10.5
        }
    ],
    "designAssumptions": [
        {
            "name": "Chamber internal dimensions",
            "value": "1200 x 750mm"
        },
        {
            "name": "Excavation depth",
            "value": "2m"
        },
        {
            "name": "Excavation Length",
            "value": "2.35m"
        },
        {
            "name": "Excavation Width ",
            "value": "1.9m"
        },
        {
            "name": "Concrete base depth",
            "value": "150mm"
        },
        {
            "name": "Concrete base length x width",
            "value": "1.75 x1.13m"
        },
        {
            "name": "Sand bedding depth",
            "value": "150mm"
        },
        {
            "name": "Sand bedding length x width",
            "value": "1.75 x1.13m"
        }
    ]
},
] 
 export default Typologies;